const nl = {
  startStopAdmin: {
    nRecords1: "{{n}} registratie",
    tNFields1: "{{n}} veld",
    totMapF1: "wegafstand van {{n}} deel",
    tAttachTitle: "Bijlagen / foto's",
    stStopped: "Voltooid",
    stStarted: "Gestart",
    stPending: "In afwachting",
    stMissing: "In afwachting · niet gedaan",
    allStatuses: "Alle statussen",
    allDepots: "Alle depots",
    allRoutes: "Alle routes",
    allEmployees: "Alle medewerkers",
    clear: "Wissen",
    search: "Zoeken…",
    nRecords: "{{n}} registraties",
    noRecords: "Geen registraties",
    title: "Start-Stop-registraties",
    subtitle: "Klik op een rij: locaties, kaart, afstanden en foto's",
    kTotal: "Totaal ritten",
    kMissing: "Verplicht, niet gedaan",
    kTimeChanged: "Tijd gewijzigd",
    kOdometer: "Teller-km",
    timeChanged: "Tijd is gewijzigd",
    thEmployee: "Medewerker",
    thDate: "Datum",
    thStatus: "Status",
    thDuration: "Duur",
    details: "Details",
    corrShort: "corr.",
    loadFailed: "Laden mislukt",
    resetDone: "Registratie gereset",
    resetFailed: "Resetten mislukt",
    dur: "{{h}}u {{m}}m",
    yes: "Ja",
    no: "Nee",
    lgStop: "Stops",
    lgRemaining: "Resterende stops",
    lgPackages: "Resterende pakketten",
    lgPickup: "Pickup",
    lgNote: "Notitie",
    startKm: "Begin-km",
    endKm: "Eind-km",
    startTime: "Starttijd",
    endTime: "Eindtijd",
    pToday: "Vandaag",
    pYesterday: "Gisteren",
    pLast7: "Laatste 7 dagen",
    pThisWeek: "Deze week",
    pLastWeek: "Vorige week",
    pThisMonth: "Deze maand",
    pLastMonth: "Vorige maand",
    xDate: "Datum",
    xEmployee: "Medewerker",
    xRoute: "Route",
    xDepot: "Depot",
    xStatus: "Status",
    xRequired: "Verplicht",
    xStartTime: "Starttijd",
    xStartSent: "Start verzonden",
    xStartKm: "Start-km",
    xStartAddr: "Startadres",
    xStartCoord: "Startcoördinaten",
    xStopTime: "Stoptijd",
    xStopSent: "Stop verzonden",
    xStopKm: "Stop-km",
    xStopAddr: "Stopadres",
    xStopCoord: "Stopcoördinaten",
    xTotalKm: "Totaal km",
    xDuration: "Duur (min)",
    xCorrected: "Gecorrigeerd",
    noStart: "Geen Start",
    noStop: "Geen Stop",
    completeStop: "Stop afronden",
    edit: "Bewerken",
    nextDay: "volgende dag",
    byAdminCompleted: "Afgerond door admin",
    byAdminEdited: "Gecorrigeerd door admin",
    sentAt: "Verzonden {{time}} ({{diff}} min)",
    mapFailed: "Kaart kon niet worden geladen",
    computing: "Afstanden berekenen…",
    noCorrections: "Geen correcties",
    adminStopCompleted: "Admin · Stop afgerond",
    reason: "Reden",
    lat: "Breedtegraad",
    lng: "Lengtegraad",
    address: "Adres",
    corrected: "gecorrigeerd",
    nReminders: "{{n}} herinneringen",
    kmOdo: "{{km}} km teller",
    windowClosed: "Stoptijd verlopen ({{at}}). De chauffeur kan niet meer stoppen; sluit af met \"Stop afronden\".",
    secRoute: "Route en afstanden",
    secFiles: "Foto's & documenten ({{n}})",
    none: "Geen",
    secCorrections: "Correctiegeschiedenis",
    noDepotLoc: "Geen locatie ingesteld voor <b>{{depot}}</b>. Bewerk het depot via Planning → Depots en voeg een locatie toe om Depot→Start en Stop→Depot te berekenen.",
    depot: "Depot",
    legDepotStart: "Depot → Eerste Start",
    legOdo: "Start → Stop (kilometerteller)",
    legOdoSub: "Eind-km − Begin-km",
    onMap: "{{km}} km op kaart",
    legStopDepot: "Laatste Stop → Depot",
    road: "wegafstand",
    straight: "hemelsbreed (geen weg gevonden)",
    aboutMin: "~{{m}} min",
    totOdo: "Totaal (teller + uiteinden)",
    totOdoF: "Depot→Start + teller + Stop→Depot",
    totOdoOnly: "alleen teller (geen depotlocatie)",
    totMap: "Totaal (alles via kaart)",
    totMapF: "wegafstand van {{n}} delen",
    mapLayer: "Kaart / Satelliet",
    satellite: "Satelliet",
    map: "Kaart",
    fullscreen: "Volledig scherm",
    exitFullscreen: "Volledig scherm sluiten",
    pinDepot: "DEPOT",
    resetTitle: "Registratie resetten",
    resetConfirmTitle: "Deze registratie resetten?",
    resetConfirmBody: "De Start-Stop-registratie, foto's en correcties worden verwijderd; de medewerker kan opnieuw Start/Stop doen. Dit kan niet ongedaan worden gemaakt.",
    cancel: "Annuleren",
    resetYes: "Ja, resetten",
    remBtn: "Herinneringen",
    remTitle: "Start-Stop-herinneringen",
    remDesc: "Chauffeurs die niet op Start of Stop drukten krijgen een pushmelding.",
    remLoadFailed: "Instellingen konden niet worden geladen",
    remSaved: "Herinneringsinstellingen opgeslagen",
    remInvalid: "Controleer de waarden (uren 1–24, herhaling 15–360 min)",
    saveFailed: "Opslaan mislukt",
    remEnabled: "Herinneringen aan",
    remHours: "Uren na Start",
    remHoursDesc: "Eerste melding als deze tijd verstreken is zonder Stop",
    hours: "uur",
    min: "min",
    remRepeat: "Nog één keer herinneren",
    remRepeatDesc: "Tweede melding als er nog steeds geen Stop is",
    remSecond: "Tweede herinnering",
    remSecondDesc: "Minuten na de eerste",
    remAdmins: "Overzicht naar admins",
    remAdminsDesc: "Na de laatste herinnering krijgen bedrijfsadmins een lijst van wie niet stopte",
    remEvery: "Elke 5 minuten gecontroleerd.",
    save: "Opslaan",
    saving: "Opslaan…",
    locInvalid: "Locatie moet \"breedtegraad, lengtegraad\" zijn",
    endTimeRequired: "Eindtijd is verplicht",
    reasonMin: "Geef een reden (minstens 3 tekens)",
    stopCompleted: "Stop afgerond",
    recordCorrected: "Registratie gecorrigeerd",
    editTitleStart: "Startgegevens bewerken",
    editTitleStop: "Stopgegevens bewerken",
    editDesc: "Oude en nieuwe waarden worden in de geschiedenis vastgelegd.",
    locLabel: "Locatie (breedtegraad, lengtegraad)",
    reasonLabel: "Reden *",
    reasonPh: "bv. Chauffeur vergat te stoppen, telefonisch bevestigd",
    complete: "Afronden",
    tSsMode: "Start-Stop-modus",
    tSsModeDesc: "Er verschijnt een grote Start-knop op het dashboard van de medewerker; de rit eindigt met Stop. Kies hieronder welke velden bij Start en welke bij Stop gevraagd worden.",
    tRequired: "Verplicht",
    tRequiredDesc: "Het formulier kan niet worden verzonden zonder Start/Stop; wie het overslaat, staat rood op de Start-Stop-pagina.",
    tHideForm: "Overige formuliervelden verbergen",
    tHideFormDesc: "Aangevinkt: alleen de Start/Stop-schermen. Niet aangevinkt: velden 'In formulier' worden apart ingevuld.",
    tHideRouteReport: "Oud \"Rit melden\"-formulier verbergen",
    tHideRouteReportDesc: "Aangevinkt: chauffeurs op deze planning zien de oude \"Rit melden\"-knop niet, alleen Start/Stop.",
    tWindow: "Start-Stop-tijdvenster",
    tWindowStart: "Start opent",
    tWindowEnd: "Stop uiterlijk",
    tOvernight: "volgende dag · nachtrit",
    tClear: "wissen",
    tWindowSet: "De chauffeur kan Start/Stop doen van {{ws}} op de opdrachtdag tot {{nd}}{{we}}. Daarna rondt een admin open ritten af.",
    tNextDayPrefix: "de volgende dag ",
    tWindowEmpty: "Leeg: opdrachtdag 00:00–24:00. Voor nachtritten bv. 20:00 → 10:00 (een vroeger einde telt als volgende dag).",
    pFillDepot: "Depotcoördinaten invullen",
    pUsesDepot: "Indien leeg worden de depotcoördinaten gebruikt ({{c}})",
    pOpenMap: "Openen op kaart",
    pPointLabelPh: "bv. Klantendepot Genk",
    pPointLabel: "Locatienaam (zichtbaar voor chauffeur)",
    pCoordsInvalid: "Ongeldig formaat. Voorbeeld: 51.17452,5.82870",
    pCoords: "Startcoördinaten (lat,lng)",
    simToStart: "Rijdt depot → Start",
    simTour: "Op rit (levering)",
    simBack: "Terug naar depot",
    simAtDepot: "Terug in depot",
    simReset: "Terugspoelen",
    nMin: "{{m}} min",
    departDepot: "Vertrek depot",
    returnDepot: "Terugkomst depot",
    workTotal: "Totale werktijd",
    workFormula: "Vertrek depot (Start − rijtijd depot→Start) → terugkomst depot (Stop + rijtijd Stop→depot)",
    workEstimated: "Rijtijden deels geschat (routeservice niet beschikbaar)",
    workNoDepot: "Geen depotcoördinaten — alleen Start→Stop-tijd",
    nfStart: "Start-herinnering",
    nfClose: "Stop-deadline: nog {{m}} min",
    nfOverdue: "Herinnering late Stop",
    noNotifs: "Nog geen meldingen verstuurd",
    secNotifs: "Meldingsgeschiedenis ({{n}})",
    workShort: "Totaal {{d}}",
    thWork: "Totale werktijd",
    kWork: "Totale werktijd",
    kWorkAvg: "Gem. {{d}} · ritten: {{n}}",
    kWorkNone: "Geen afgeronde ritten",
    pTitle: "Vaste starttijd en locatie",
    pDesc: "De medewerker vult alleen de km in en tikt op Start; tijd en locatie komen van hier en kunnen niet gewijzigd worden.",
    pDefaultTime: "Standaardtijd depot",
    pDefaultTimeCompany: "Standaardtijd",
    pRouteTimes: "Starttijd per rit",
    pUsesDefault: "standaard {{time}}",
    pFree: "vrij",
    pLocation: "Vaste startlocatie (bv. klantendepot)",
    pLocationDesc: "Deze locatie wordt bij Start geregistreerd; de telefoonlocatie wordt als back-up/log bewaard. Start werkt ook zonder locatie.",
    pNoCoords: "Geen coördinaten ingevuld en het depot heeft er geen — de telefoonlocatie wordt gebruikt.",
    pHint: "Bij ritten zonder tijd vult de medewerker die zelf in. Meldingen: 5 keer tijdens het Start-venster en 60/30/10 min voor de Stop-deadline.",
    presetTimeBadge: "Vaste tijd · getikt {{time}}",
    presetLocBadge: "Vaste startlocatie",
    deviceLoc: "Telefoonlocatie (back-up)",
    deviceLocNone: "Telefoonlocatie niet beschikbaar",
    remStartPrompts: "Start-herinnering (5 keer)",
    remStartPromptsDesc: "Indien niet gestart, gelijk verdeeld van opening tot starttijd",
    remClose: "Stop-deadline herinnering",
    remCloseDesc: "Indien geen Stop, 60, 30 en 10 min voor de deadline",
    tAskStart: "Gevraagd bij Start",
    tAskStop: "Gevraagd bij Stop",
    tNFields: "{{n}} velden",
    tAutoLoc: "Locatie en tijd worden altijd automatisch vastgelegd",
    tNoFields: "Nog geen velden",
    tUnnamed: "(naamloos)",
    tKmPhoto: "KM + foto",
    tKmPhotoTitle: "De medewerker typt de km en kan optioneel de teller fotograferen",
    tRemoveFromPhase: "Uit deze fase halen (terug naar formulier)",
    tAttachMulti: "(meerdere)",
    tShow: "Tonen",
    tAddKm: "{{label}} toevoegen (typen of foto)",
    tPickExisting: "+ Bestaand formulierveld kiezen…",
    tNewField: "Nieuw veld toevoegen",
    tFieldNamePh: "Veldnaam (bv. Aantal stops)",
    tAdd: "Toevoegen",
    tAllFields: "Alle formuliervelden — waar vragen?",
    tInForm: "In formulier",
    tTimeLocked: "De tijd wordt automatisch vastgelegd op het Start/Stop-scherm",
    tHint: "Een veld wordt op één plek gevraagd. Bij een KM-veld in Start/Stop typt de medewerker de km en kan optioneel de teller fotograferen. Tijdvelden kunnen niet worden verplaatst; Start/Stop legt de tijd zelf vast.",
    tAtStart: "Bij Start",
    tAtStop: "Bij Stop",
    ty_text: "Tekst",
    ty_number: "Getal",
    ty_time: "Tijd",
    ty_date: "Datum",
    ty_photo: "Foto",
    ty_boolean: "Ja/Nee",
    ty_select: "Keuze",
  },
  startStop: {
    todayBadge: "VANDAAG",
    tomorrowBadge: "MORGEN",
    afterStop: "Na Stop",
    overnight: "Nachtrit van gisteren · Stop uiterlijk {{time}}",
    overnightBadge: "GISTERAVOND",
    startOpensAt: "Start opent om {{time}}",
    stopDeadline: "Stop uiterlijk {{time}}",
    nextDay: "(volgende dag)",
    windowClosed: "Start-Stop-tijd is verlopen",
    closedManagerCompletes: "Uw leidinggevende rondt uw rit af.",
    closedInformManager: "Breng uw leidinggevende op de hoogte.",
    startTour: "Rit starten",
    required: "verplicht",
    running: "Rit bezig",
    startLabel: "Start",
    startKmShort: "Start-km",
    photo: "foto",
    finished: "Rit voltooid",
    correctionUsed: "Correctie al gebruikt",
    correctLast: "Laatste gegevens corrigeren (1 keer)",
    elapsed: "{{h}} u {{m}} min",
    yes: "Ja",
    no: "Nee",
    saveFailed: "Opslaan mislukt",
    optional: "(optioneel)",
    noLocStart: "Starten zonder locatie is niet mogelijk",
    noLocStop: "Afronden zonder locatie is niet mogelijk",
    orPhoto: "(of foto)",
    missing: "Ontbreekt: {{list}}",
    startKm: "Begin-km",
    endKm: "Eind-km",
    startTime: "Starttijd",
    endTime: "Eindtijd",
    timeHint: "Als u dit wijzigt, wordt de werkelijke verzendtijd ook opgeslagen",
    kmHintStart: "Typ het in of fotografeer de kilometerteller met de camera rechts",
    kmHintStop: "Typ het in of fotografeer de kilometerteller",
    startedTitle: "Rit gestart",
    goodWork: "Succes vandaag!",
    canClose: "U kunt dit scherm sluiten. Tik hier op STOP als de rit klaar is.",
    startTitle: "Rit starten",
    takePhoto: "Foto maken",
    addFile: "Bestand toevoegen",
    attachments: "Bijlagen",
    attachmentsPhotos: "Bijlagen / foto's",
    endKmLess: "Eind-km mag niet lager zijn dan start ({{km}})",
    filesUploading: "Bestanden worden geüpload, even geduld",
    savedThanks: "Rit opgeslagen, bedankt!",
    totalKm: "Totaal {{km}} km",
    recordReceived: "Registratie ontvangen",
    oneCorrection: "Iets verkeerd ingevuld? U kunt het één keer corrigeren.",
    stopTitle: "Rit afronden",
    stopSave: "STOP · Opslaan",
    reasonRequired: "Geef de reden van de correctie op",
    noChange: "Geen wijzigingen",
    correctionSaved: "Correctie opgeslagen",
    correctTitle: "Laatste gegevens corrigeren",
    correctSubtitle: "U heeft één correctie; deze wordt vastgelegd",
    saveCorrection: "Correctie opslaan",
    correctionReason: "Reden van correctie *",
    reasonPlaceholder: "bv. km verkeerd ingetypt",
    okClose: "OK, scherm sluiten",
    geoUnsupported: "Uw apparaat ondersteunt geen locatie",
    geoDenied: "Locatietoestemming geweigerd. Sta locatie toe voor deze site in uw browserinstellingen en probeer opnieuw.",
    geoFailed: "Locatie niet gevonden. Probeer het buiten opnieuw.",
    geoOk: "Locatie ontvangen",
    presetLocation: "Startlocatie: {{depot}} (ingesteld)",
    presetTimeHint: "Starttijd is ingesteld door je leidinggevende",
    refresh: "Vernieuwen",
    geoRetry: "Locatie opnieuw proberen",
    geoLoading: "Locatie ophalen… tik op \"Toestaan\" als erom gevraagd wordt",
    kmPhotoUploaded: "Kilometerfoto geüpload",
    photoUploadFailed: "Foto uploaden mislukt",
    kmPlaceholder: "bv. 125430",
    kmPhotoTitle: "Kilometerteller fotograferen",
    now: "Nu",
    photoAdded: "Foto toegevoegd · wijzigen",
    takePhotoFull: "Foto maken",
    geoModalTitle: "Uw locatie kon niet worden bepaald",
    geoWaiting: "Wachten op locatie…",
    geoRequired: "Start / Stop kan niet zonder locatie worden verzonden.",
    gettingLocation: "Locatie ophalen…",
    retry: "Opnieuw proberen",
    close: "Sluiten",
    overdueTitle: "Vergeten te stoppen?",
    overdueBody: "Uw rit staat al {{h}} uur open. Klaar? Tik nu op Stop.",
    stepsDeniedIos: ["Instellingen → Privacy → Locatievoorzieningen aan", "Instellingen → Safari (of de app) → Locatie → \"Vraag\" of \"Sta toe\"", "Kom terug naar deze pagina en tik op \"Opnieuw proberen\""],
    stepsDeniedAndroid: ["Tik op het slotje in de adresbalk", "Rechten → Locatie → \"Toestaan\"", "Zet de locatie (GPS) van de telefoon aan en tik op \"Opnieuw proberen\""],
    stepsOther: ["Zet de locatie (GPS) van de telefoon aan", "Bent u binnen? Ga naar buiten", "Tik op \"Opnieuw proberen\""],
  },
  common: {
    welcome: "Welkom",
    login: "Inloggen",
    register: "Registreren",
    logout: "Uitloggen",
    dashboard: "Dashboard",
    profile: "Profiel",
    settings: "Instellingen",
    security: "Beveiliging",
    users: "Gebruikers",
    firms: "Bedrijven",
    save: "Opslaan",
    cancel: "Annuleren",
    delete: "Verwijderen",
    edit: "Bewerken",
    create: "Aanmaken",
    yes: "Ja",
    no: "Nee",
    approve: "Goedkeuren",
    reject: "Afwijzen",
    pending: "In afwachting",
    active: "Actief",
    rejected: "Afgewezen",
    search: "Zoeken",
    year: "Jaar",
    month: "Maand",
    day: "Dag",
    unknown: "Onbekend",
    firmDistribution: "Bedrijfsverdeling",
    loading: "Laden...",
    error: "Fout",
    success: "Succes",
    back: "Terug",
    next: "Volgende",
    submit: "Verzenden",
    actions: "Acties",
    noData: "Geen gegevens gevonden",
    confirmDelete: "Weet u zeker dat u wilt verwijderen?",
    auditLogs: "Auditlogboeken",
    leaveRequests: "Verlofaanvragen",
    confirm: "Bevestigen",
    confirmation: "Bevestiging",
    all: "Alles",
    firm: "Bedrijf",
    refresh: "Vernieuwen",
    total: "Totaal",
    email: "E-mailadres",
    language: "Taal",
    filter: "Filter",
    clearFilter: "Filter Wissen",
    clearAll: "Alles Wissen",
    close: "Sluiten",
    noResults: "Geen resultaten gevonden",
    from: "Van",
    to: "Tot",
    name: "Naam",
    status: "Status",
    type: "Type",
    date: "Datum",
    amount: "Bedrag",
    description: "Beschrijving",
    details: "Details",
    view: "Bekijken",
    download: "Downloaden",
    upload: "Uploaden",
    add: "Toevoegen",
    remove: "Verwijderen",
    select: "Selecteren",
    selected: "Geselecteerd",
    none: "Geen",
    period: "Periode",
    collapseMenu: "Menu Inklappen",
    expandMenu: "Menu Uitklappen",
    darkMode: "Donkere Modus",
    lightMode: "Lichte Modus",
    colorTheme: "Kleurthema",
    minutes: "min",
    clear: "Wissen",
    clearFilters: "Filters wissen",
    dateRange: "Datumbereik",
    filters: "Filters",
    globalSearch: "Zoek medewerker of kenteken...",
    lastMonth: "Vorige maand",
    more: "meer",
    optional: "optioneel",
    page: "Pagina",
    perPage: "per pagina",
    previous: "Vorige",
    records: "records",
    refreshed: "Vernieuwd",
    show: "Tonen",
    showing: "Tonen",
    vehicleBadge: "Voertuig",
    unassigned: "Niet toegewezen",
    allFirms: "Alle Bedrijven",
    selectFirm: "Selecteer bedrijf",
    accessDenied: "Toegang Geweigerd",
    document: "Document",
    inactive: "Inactief",
    processing: "Verwerken...",
    saving: "Opslaan...",
    sending: "Verzenden...",
    deselectAll: "Alles Deselecteren",
    selectAll: "Alles Selecteren",
    allDepos: "Alle Depots",
    noDepo: "Geen Depot",
    reset: "Reset",
    showSold: "Verkocht tonen",
    sold: "VERKOCHT",
    saleDate: "Verkoopdatum",
    saleDateHint: "Als verkoopdatum is ingevuld, wordt het voertuig als verkocht beschouwd",
    inVehicle: "In voertuig",
    outVehicle: "Buiten voertuig",
    purchaseDate: "Aankoopdatum",
    saved: "Opgeslagen",
    addNote: "Notitie Toevoegen",
    noFilterResults: "Geen medewerkers gevonden voor de geselecteerde filters",
    startDate: "Start",
    endDate: "Einde",
  },
  imageCropper: {
    title: "Afbeelding Bewerken",
    selectFile: "Bestand Selecteren",
    dragDrop: "Sleep afbeelding hierheen",
    or: "of",
    preview: "Voorbeeld",
    reset: "Resetten",
    rotate: "Draaien",
    changeImage: "Afbeelding Wijzigen",
    upload: "Uploaden",
    zoom: "Zoom",
    paste: "Plakken",
    pasteHint: "Plak met Ctrl+V",
  },
  documentEditor: {
    dragDropTitle: "Sleep document hierheen",
    supportedFormats: "JPG, PNG, WEBP, PDF ondersteund",
    selectFile: "Bestand Selecteren",
    pasteFromClipboard: "Plakken van Klembord",
    pasteHint: "U kunt direct plakken vanuit het klembord met Ctrl+V",
    rotateLeft: "Links Draaien",
    rotateRight: "Rechts Draaien",
    flipHorizontal: "Horizontaal Spiegelen",
    flipVertical: "Verticaal Spiegelen",
    reset: "Resetten",
    changeImage: "Ander Bestand Kiezen",
    skipEdit: "Uploaden Zonder Bewerking",
    cropAndUpload: "Bijsnijden en Uploaden",
    deleteConfirm: "Weet u zeker dat u dit document wilt verwijderen?",
    deleteDocument: "Document verwijderen",
    deleteSuccess: "Document succesvol verwijderd",
    processing: "Verwerken...",
    save: "Opslaan",
    saveAndUpload: "Opslaan en uploaden",
  },
  nav: {
    lockedDates: "Geblokkeerde Datums",
    frontendSettings: "Weergave-instellingen",
    siteSettings: "Site-instellingen",
    myDocuments: "Mijn Documenten",
    myPayslips: "Mijn Loonbrieven",
    myPackages: "Mijn Pakketten",
    myFinance: "Mijn Financiën",
    personalMenu: "Persoonlijk",
    myNotifications: "Mijn Meldingen",
    documentManagement: "Documentbeheer",
    docManagement: "Documenten",
    loonbrief: "Loonbrief Uploaden",
    loonbriefList: "Loonbrief Lijst",
    pdfUpload: "PDF Uploaden",
    sendNotification: "Melding Versturen",
    routes: "Routes",
    allRoutes: "Alle Routes",
    routeReports: "Route Rapporten",
    fuelReports: "Dagrapport Brandstof",
    vehicles: "Mijn Voertuigen",
    allUsers: "Alle Gebruikers",
    languages: "Talen",
    databaseBackup: "Database Backup",
    postnlCodes: "PostNL Codes",
    planning: "Planning",
    messages: "Berichten",
    chat: "Chat",
    todoList: "Takenlijst",
    communication: "Communicatie",
    dpd: "DPD",
    dpdDailySummary: "DPD Dagoverzicht",
    dpdDriverPerformance: "DPD Chauffeur Prestaties",
    dpdConsolidated: "DPD Geconsolideerd Rapport",
    dpdMonthlyInvoice: "DPD Maandelijkse Facturatie",
    dpdRetourHeatmap: "DPD Retour Heatmap",
    dpdSubcoComparison: "DPD Subco Vergelijking",
    dpdCourierMapping: "DPD Chauffeur Matching",
    dpdRetourReport: "DPD Retour Rapport",
    dpdFileCategories: "DPD Bestandscategorieën",
    dpdAnalytics: "DPD Analytics & Inzichten",
  },
  fields: {
    firm_id: "Bedrijfsselectie",
    date: "Datum",
    route_number: "Routenummer",
    route_type: "Route Type",
    rit: "Rit",
    vehicle_plate: "Kenteken",
    driver: "Chauffeur",
    copilot: "Copiloot",
    km_start: "KM Start",
    km_end: "KM Einde",
    stops: "Stops",
    stop_price: "Stop Prijs",
    hourly_rate: "Uurtarief (€)",
    start_cost: "Startkosten (€)",
    start_time: "Starttijd",
    end_time: "Eindtijd",
    break_time: "Pauzetijd",
    totaal_excl_btw: "Totaal excl BTW",
  },
  calcTypes: {
    hours_rate: "Uren × Tarief + Startkosten",
    stops_price: "Stops × Stopprijs",
    fixed_rate: "Vast Tarief + Startkosten",
    manual_total: "Startkosten = Totaal",
  },
  fuelReports: {
    title: "Dagrapport Brandstof",
    subtitle: "Brandstofrapport",
    date: "Datum",
    plate: "Nummerplaat",
    tankCard: "Tankkaart",
    driver: "Chauffeur",
    liters: "Liter",
    pricePerLiter: "€/Liter",
    total: "Totaal",
    period: "Periode",
    totalRecords: "Records",
    totalLiters: "Totaal Liter",
    totalCost: "Totale Kosten",
    searchPlaceholder: "Zoek op chauffeur, plaat of tankkaart...",
    add: "Nieuw Brandstofrecord",
    edit: "Brandstofrecord Bewerken",
    importTitle: "Importeer vanuit Excel",
    startDate: "Startdatum",
    endDate: "Einddatum",
    notes: "Opmerkingen",
    attachments: "Bijlagen",
    loadError: "Gegevens konden niet worden geladen",
    dateAndPlateRequired: "Datum en kenteken zijn verplicht",
    updated: "Bijgewerkt",
    added: "Toegevoegd",
    errorOccurred: "Er is een fout opgetreden",
    operationFailed: "Bewerking mislukt",
    deleted: "Verwijderd",
    cannotDelete: "Kan niet verwijderen",
    fileAndFirmRequired: "Bestand en bedrijfsselectie zijn verplicht",
    importSuccess: "{{count}} records geïmporteerd",
    importFailed: "Import mislukt",
    fileUploaded: "Bestand geüpload",
    uploadFailed: "Upload mislukt",
    fileDeleted: "Bestand verwijderd",
    fileTooLarge: "Kan niet groter zijn dan 10MB",
    fileUploadFailed: "kon niet worden geüpload",
    excelImport: "Excel Importeren",
    selectDriver: "Selecteer chauffeur",
    searchDriver: "Zoek en selecteer chauffeur...",
    selectFirmFirst: "Selecteer eerst een bedrijf",
    searchDriverPlaceholder: "Zoek chauffeur...",
    driverNotFound: "Chauffeur niet gevonden",
    manualEntry: "of voer handmatig in",
    servicePartner: "Service Partner",
    clone: "Klonen",
    cloned: "Record gekloond met huidige datum",
    noRecords: "Geen records gevonden",
    deleteConfirm: "Weet u zeker dat u dit record wilt verwijderen?",
    matched: "Gekoppeld",
    selectPlate: "Selecteer kenteken",
    searchPlate: "Kenteken zoeken...",
    plateNotFound: "Kenteken niet gevonden",
    addFile: "Bestand toevoegen",
    noAttachments: "Geen bijlagen",
    importing: "Importeren...",
    import: "Importeren",
    manualDriverEntry: "of voer chauffeursnaam in",
    dragDropFiles: "Sleep bestanden of klik om te uploaden",
    delete: "Verwijderen",
  },
  loonbrief: {
    description: "Verdeel automatisch loonbrief PDF's naar werknemers",
    uploadSettings: "Upload Instellingen",
    firm: "Bedrijf",
    firmRequired: "Bedrijf *",
    selectFirm: "Selecteer bedrijf...",
    period: "Periode",
    periodRequired: "Periode *",
    selectPeriod: "Selecteer periode...",
    pdfUpload: "PDF Uploaden",
    selectFirmFirst: "Selecteer eerst een bedrijf",
    selectPeriodFirst: "Selecteer eerst een periode",
    processing: "PDF wordt verwerkt, even geduld...",
    processSuccess: "PDF verwerkt",
    processError: "Fout bij verwerken PDF",
    matched: "gematcht",
    unmatched: "niet gematcht",
    results: "Verwerkingsresultaten",
    page: "Pagina",
    nameFromPdf: "Naam uit PDF",
    matchedEmployee: "Gematchte Werknemer",
    status: "Status",
    action: "Actie",
    statusMatched: "Gematcht",
    statusUnmatched: "Niet Gematcht",
    statusError: "Fout",
    manualMatch: "Handmatig Matchen",
    manualMatchTitle: "Handmatig Matchen",
    nameInPdf: "Naam in PDF:",
    searchEmployee: "Zoek werknemer...",
    employeeNotFound: "Werknemer niet gevonden",
    matchSuccess: "gematcht met",
    aliases: "Aliassen",
    naam: "Naam",
    clear: "Wissen",
    saveMatched: "Gematchte Opslaan",
    noMatchedToSave: "Geen gematchte loonbrieven om op te slaan",
    pdfNotFound: "PDF-bestand niet gevonden, upload opnieuw",
    saveSuccess: "loonbrieven succesvol opgeslagen",
    savePartialError: "loonbrieven konden niet worden opgeslagen",
    saveError: "Fout bij opslaan",
    employeesLoaded: "werknemers geladen",
    employeesWithAliases: "werknemers hebben aliassen",
    cancel: "Annuleren",
    saveSummaryTitle: "Opslagresultaten",
    saveSummaryDesc: "Het opslagproces van loonbrieven is voltooid.",
    summarySaved: "Opgeslagen",
    summaryErrors: "Fouten",
    summaryUnmatched: "Niet gematcht",
    summarySuccessTitle: "Succesvol Opgeslagen Loonbrieven",
    summaryErrorTitle: "Mislukte Records",
    summaryUnmatchedTitle: "Niet-gematchte Werknemers",
    summaryUpdated: "Bijgewerkt",
    unmatchedHint: "Deze werknemers zijn mogelijk niet in het systeem geregistreerd of hun namen hebben een ander formaat. U kunt handmatig matchen.",
    close: "Sluiten",
  },
  languages: {
    subtitle: "Systeemvertalingen bewerken",
    syncComplete: "Synchronisatie voltooid!",
    syncCompleteDesc: "{added} nieuw toegevoegd, {updated} bijgewerkt, {skipped} overgeslagen",
    syncFailed: "Synchronisatie mislukt",
    translationSaved: "Vertaling opgeslagen in database",
    translationSaveFailed: "Vertaling kon niet worden opgeslagen",
    keyNameRequired: "Sleutelnaam is verplicht",
    keyAlreadyExists: "Deze sleutel bestaat al",
    atLeastOneValue: "Voer minstens één vertalingswaarde in",
    newKeyAdded: "Nieuwe vertalingssleutel toegevoegd",
    addKeyFailed: "Vertaling kon niet worden toegevoegd",
    exported: "Vertalingen geëxporteerd",
    invalidFileFormat: "Ongeldig bestandsformaat. JSON-bestand moet {tr: {...}, en: {...}, ...} structuur hebben",
    analysisFailed: "Bestandsanalyse mislukt",
    invalidJson: "Ongeldig JSON-bestand",
    importComplete: "Import voltooid!",
    importCompleteDesc: "{added} nieuw, {updated} bijgewerkt, {skipped} overgeslagen",
    importFailed: "Import mislukt",
    cacheCleared: "Cache gewist, teruggezet naar standaardvertalingen",
    translationsTab: "Vertalingen",
    scanTab: "Ontbrekende Detectie",
    scanTitle: "Ontbrekende Vertaalsleutel Detectie",
    scanDescription: "Detecteert vertaalsleutels die in de broncode worden gebruikt maar niet zijn gedefinieerd, en taalverschillen.",
    scanBtn: "Start Scan",
    scanning: "Scannen...",
    scanComplete: "Scan voltooid",
    scanFailed: "Scan mislukt",
    scanKeysScanned: "Gescand in Code",
    scanKeysDefined: "Gedefinieerd in i18n",
    scanUndefined: "Ongedefinieerde Sleutel",
    scanCrossLang: "Meertalig Ontbrekend",
    scanSearchPlaceholder: "Zoek sleutel...",
    allLanguages: "Alle Talen",
    undefinedInCode: "Sleutels Gebruikt in Code maar Niet Gedefinieerd",
    undefinedInCodeDesc: "Deze sleutels worden aangeroepen met t() maar zijn in geen enkele taal gedefinieerd.",
    crossLangMissing: "Meertalig Ontbrekende Sleutels",
    crossLangMissingDesc: "Deze sleutels zijn in sommige talen gedefinieerd maar ontbreken in andere.",
    missingInLangs: "Ontbreekt In",
    presentInLangs: "Aanwezig In",
    allKeysComplete: "Alle Sleutels Volledig!",
    allKeysCompleteDesc: "Alle gebruikte vertaalsleutels zijn in alle talen gedefinieerd.",
    scanPrompt: "Start een scan om ontbrekende vertaalsleutels te detecteren",
    scanPromptDesc: "Broncodebestanden worden gescand en vergeleken met i18n-definities.",
    scanningInProgress: "Broncode wordt gescand...",
    synced: "Gesynchroniseerd",
    syncToDb: "Sync naar DB",
    newKey: "Nieuwe Sleutel",
    export: "Exporteren",
    analyzing: "Analyseren...",
    import: "Importeren",
    reset: "Resetten",
    missing: "ontbreekt",
    complete: "Compleet",
    filteringMissing: "Ontbrekende vertalingen filteren...",
    searchPlaceholder: "Zoek sleutel of waarde...",
    selectNamespace: "Selecteer namespace",
    allNamespaces: "Alle Namespaces",
    perPageSuffix: "/ pagina",
    allMissing: "Alle Ontbrekende",
    clearFilter: "Filter Wissen",
    translationsTitle: "Vertalingen",
    translationsFound: "vertalingen gevonden",
    missingFor: "ontbrekend",
    allMissingLabel: "Alle ontbrekende",
    keyColumn: "Sleutel",
    actionColumn: "Actie",
    missingValue: "(ontbreekt)",
    noResults: "Geen resultaten gevonden",
    pageLabel: "Pagina",
    editTitle: "Vertaling Bewerken",
    missingBadge: "Ontbreekt",
    translationPlaceholder: "vertaling...",
    cancel: "Annuleren",
    saving: "Opslaan...",
    save: "Opslaan",
    addTitle: "Nieuwe Vertalingssleutel Toevoegen",
    addDescription: "Sleutelformaat: namespace.key (bijv.: common.newFeature)",
    keyName: "Sleutelnaam",
    keyPlaceholder: "bijv.: common.addFinancialRecord",
    translationValues: "Vertalingswaarden",
    adding: "Toevoegen...",
    add: "Toevoegen",
    importPreviewTitle: "Importvoorbeeld",
    importPreviewDesc: "Bestand geanalyseerd. De volgende wijzigingen worden aangebracht:",
    willAdd: "Wordt Toegevoegd",
    willUpdate: "Wordt Bijgewerkt",
    totalKeys: "Totaal Sleutels",
    importMode: "Importmodus:",
    modeMerge: "Samenvoegen (Aanbevolen)",
    modeSkip: "Bestaande Overslaan",
    modeOverwrite: "Overschrijven",
    modeMergeDesc: "Bestaande waarden worden behouden, nieuwe waarden worden toegevoegd/bijgewerkt",
    modeSkipDesc: "Alleen nieuwe sleutels worden toegevoegd, bestaande blijven ongewijzigd",
    modeOverwriteDesc: "Alle waarden worden vervangen door de bestandsinhoud",
    keysAlreadyExist: "sleutels bestaan al",
    keysAlreadyExistDesc: "Deze sleutels worden bijgewerkt.",
    protectExisting: "modus om bestaande waarden te behouden.",
    newKeysToAdd: "Nieuwe Sleutels om Toe te Voegen",
    andMoreKeys: "... en {count} meer sleutels",
    keysToUpdate: "Sleutels om Bij te Werken",
    existingToNew: "Huidig → Nieuwe waarden",
    importing: "Importeren...",
    syncTitle: "Vertalingen Synchroniseren naar Database",
    syncDesc: "Breng alle vertalingen van i18n.js over naar MongoDB. Dit voegt alleen ontbrekende sleutels toe en behoudt uw bewerkingen.",
    inI18n: "In i18n.js",
    inDb: "In Database",
    toBeAdded: "Toe te Voegen",
    whatDoesThisDo: "Wat doet dit?",
    syncInfo1: "Leest alle vertalingen uit i18n.js bestand",
    syncInfo2: "Voegt sleutels toe die niet in de DB staan",
    syncInfo3: "BEHOUDT bestaande (overschrijft niet)",
    syncInfo4: "DB wordt de Single Source of Truth",
    dbSynced: "Database is gesynchroniseerd!",
    dbSyncedDesc: "{synced} van i18n, {added} door gebruikers toegevoegd",
    dbNotSynced: "Database is nog niet gesynchroniseerd",
    dbNotSyncedDesc: "Druk op de knop \"Synchroniseren\" voor eerste installatie",
    syncing: "Synchroniseren...",
    syncBtn: "Synchroniseren",
  },
  lockedDates: {
    title: "Geblokkeerde Datums",
    description: "Beheer datums waarop werknemers geen verlof kunnen aanvragen",
    lockDate: "Datum Blokkeren",
    howItWorks: "Hoe werken Geblokkeerde Datums?",
    infoLine1: "Werknemers kunnen geen verlofaanvragen maken op geblokkeerde datums",
    infoLine2: "\"Jaarlijks Herhalen\" blokkeert automatisch dezelfde datums elk jaar",
    infoLine3: "U kunt datums blokkeren voor alle bedrijven of specifieke bedrijven",
    activeLockedDates: "Actieve Geblokkeerde Datums",
    recordsFound: "records gevonden",
    dates: "Datums",
    reason: "Reden",
    firms: "Bedrijven",
    repeat: "Herhaling",
    createdBy: "Aangemaakt Door",
    noLockedDates: "Geen geblokkeerde datums gevonden",
    more: "meer",
    allFirms: "Alle Bedrijven",
    everyYear: "Elk Jaar",
    oneTime: "Eenmalig",
    addNewTitle: "Nieuwe Geblokkeerde Datums Toevoegen",
    addNewDescription: "Werknemers kunnen geen verlof aanvragen op geselecteerde datums",
    selectDates: "Selecteer Datums",
    datesSelected: "datums geselecteerd",
    allFirmsApplies: "Geldt voor alle bedrijven",
    firmsSelected: "bedrijven geselecteerd",
    reasonPlaceholder: "Bijv.: Jaarlijkse inventarisatie, Bedrijfsvergadering...",
    repeatYearly: "Jaarlijks Herhalen",
    repeatYearlyDesc: "Deze datums worden automatisch elk jaar geblokkeerd",
    lockDates: "Datums Blokkeren",
    deleteTitle: "Geblokkeerde Datums Verwijderen",
    deleteConfirm: "Deze actie kan niet ongedaan worden gemaakt. Weet u zeker dat u de datumblokkering wilt verwijderen?",
    datesCreated: "Geblokkeerde datums aangemaakt",
    datesDeleted: "Geblokkeerde datums verwijderd",
    calendarView: "Kalender",
    listView: "Lijst",
    calendarTitle: "Geblokkeerde Datums Kalender",
    lockedDay: "Geblokkeerde Dag",
    today: "Vandaag",
    lockedRecords: "geblokkeerde records",
  },
  packages: {
    title: "Pakketten",
    subtitle: "Factuur- en distributiegegevens",
    fetchError: "Fout bij laden van pakketten",
    statsError: "Fout bij laden van statistieken",
    detailError: "Fout bij laden factuurdetail",
    totalInvoices: "Totaal Facturen",
    totalAmount: "Totaal Bedrag",
    totalEmployees: "Totaal Werknemers",
    totalRegions: "Totaal Regio's",
    totalQuantity: "Totaal Aantal",
    overview: "Overzicht",
    invoices: "Facturen",
    employees: "Werknemers",
    regions: "Regio's",
    weeklyTrend: "Wekelijkse Trend",
    regionDistribution: "Regio Verdeling",
    topEmployees: "Hoogste Verdienende Werknemers",
    topEmployeesByPackage: "Top Werknemers op Pakketaantal",
    invoiceList: "Facturenlijst",
    invoiceNumber: "Factuur Nr",
    invoiceDate: "Datum",
    weekNumber: "Week",
    company: "Bedrijf",
    location: "Locatie",
    employeeStats: "Werknemersstatistieken",
    employeeName: "Werknemer",
    routeDays: "Routes/Gewerkte Dagen",
    workDays: "Werkdagen",
    dailyAverage: "Dagelijks Gemiddelde",
    difference: "Verschil (165)",
    bonusCalculation: "Bonus Berekening",
    unitPrice: "Eenheidsprijs",
    calculation: "Berekening",
    dayShort: "dagen",
    clickToCopy: "Klik om te kopiëren",
    copiedToClipboard: "gekopieerd",
    totalEarnings: "Totaal Verdiensten",
    regionStats: "Regiostatistieken",
    region: "Regio",
    employeeCount: "Werknemersaantal",
    invoiceDetail: "Factuurdetail",
    year: "Jaar",
    week: "Week",
    date: "Datum",
    quantity: "Aantal",
    total: "Totaal",
    searchEmployee: "Werknemer zoeken...",
    searchInvoice: "Factuur zoeken...",
    noEmployeeFound: "Geen werknemer gevonden voor",
    employeesShown: "werknemers getoond",
    allCompanies: "Alle Bedrijven",
    allLocations: "Alle Locaties",
    noInvoiceFound: "Geen factuur gevonden voor filters",
    invoicesShown: "facturen getoond",
    deleteConfirmTitle: "Factuur Verwijderen",
    deleteConfirmMessage: "Weet u zeker dat u deze factuur en alle gerelateerde gegevens (werknemers, regio's) wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
    deleteSuccess: "Factuur succesvol verwijderd",
    deleteError: "Fout bij verwijderen factuur",
    allRegions: "Alle Regio's",
    allDates: "Alle Datums",
    unitPrice: "Eenheidsprijs",
    fixedCharge: "Vast",
    filteredQuantity: "Gefilterd Aantal",
    filteredTotal: "Gefilterd Totaal",
    regionSummary: "Regio Samenvatting",
    selected: "geselecteerd",
    deleteSelected: "Selectie Verwijderen",
    bulkDeleteTitle: "Bulk Verwijderen",
    bulkDeleteConfirmMessage: "Weet u zeker dat u deze facturen en alle gerelateerde gegevens wilt verwijderen?",
    bulkDeleteWarning: "Dit kan niet ongedaan worden gemaakt!",
    selectedInvoices: "Te Verwijderen Facturen",
    deleteAll: "Alles Verwijderen",
    invoicesDeleted: "facturen succesvol verwijderd",
    invoicesDeleteError: "facturen niet verwijderd",
    allWeeks: "Alle Weken",
    selectWeeks: "Weken Selecteren",
    selectMonth: "Maand Selecteren",
    monthsSelected: "maanden geselecteerd",
    amount: "Bedrag",
    packageCount: "Pakket",
    createdAt: "Aanmaakdatum",
    amountPerPackage: "Gemiddeld Bedrag per Pakket",
    weeklyYearComparison: "Wekelijkse Vergelijking",
    showingInvoices: "Tonen",
    perPage: "Per pagina",
    page: "Pagina",
    yearlyComparison: "Jaarlijkse Vergelijking",
    yearlyQuantity: "Jaarlijkse Pakketaantallen",
    driverLocationMatrix: "Chauffeur-Locatie Prestatiematrix",
    driverLocationMatrixDesc: "Bekijk hoe elke chauffeur presteert op verschillende locaties",
    driver: "Chauffeur",
    locationTotal: "Locatie Totaal",
    showingTopDrivers: "Top",
    drivers: "chauffeurs weergegeven",
    matrixError: "Fout bij laden prestatiematrix",
    last7Days: "Laatste 7 Dagen",
    last4Weeks: "Laatste 4 Weken",
    last3Months: "Laatste 3 Maanden",
    allTime: "Alle Tijd",
    seasonalTrends: "Seizoensgebonden Trendanalyse",
    seasonalInsights: "Seizoensgebonden Inzichten",
    monthly: "Maandelijks",
    quarterly: "Per Kwartaal",
    yearOverYearGrowth: "Jaarlijkse Groei",
    busiestByAmount: "Drukste (Bedrag)",
    busiestByPackage: "Drukste (Pakketten)",
    monthlyPattern: "Maandelijks Patroon",
    avgQuantity: "Gem. Pakketten",
    seasonalError: "Fout bij laden seizoenstendensen",
    last6MonthsVs: "Laatste 6 Maanden vs Vorige",
    last12MonthsVs: "Laatste 12 Maanden vs Vorige",
    periodGrowth: "Periodevergelijking",
    totalAmountLabel: "Totaal Bedrag",
    totalPackageLabel: "Totaal Pakketten",
    amountPerPackageLabel: "Bedrag per Pakket",
    changePercent: "Verandering (%)",
    weekLabel: "Week",
    dateRange: "Datumbereik",
    dateRangeFilter: "Filteren op Datumbereik",
    startDate: "Begin",
    endDate: "Eind",
    clearSelection: "Wissen",
    weeksSelected: "weken geselecteerd",
    last3Years: "Laatste 3 Jaar",
    last4Years: "Laatste 4 Jaar",
  },
  forgotPassword: {
    title: "Wachtwoord Vergeten?",
    subtitle: "We sturen een verificatiecode naar uw e-mailadres",
    description: "Voer uw e-mail in en we sturen u een verificatiecode.",
    enterEmail: "Voer uw e-mailadres in",
    invalidEmail: "Voer een geldig e-mailadres in",
    emailPlaceholder: "voorbeeld@bedrijf.com",
    emailHint: "Voer uw geregistreerde e-mailadres in. De verificatiecode wordt naar dit adres verzonden.",
    sendCode: "Verificatiecode Verzenden",
    verifyCode: "Code Verifiëren",
    codeSentEmail: "Verificatiecode verzonden naar uw e-mail",
    enterCode: "Voer Verificatiecode In",
    codeExpiry: "Code verloopt over 10 minuten",
    verify: "Verifiëren",
    resendCode: "Code Opnieuw Verzenden",
    codeResent: "Nieuwe code verzonden",
    codeSent: "Verificatiecode verzonden",
    codeVerified: "Code geverifieerd",
    invalidCode: "Ongeldige code",
    enterValidCode: "Voer 6-cijferige code in",
    newPassword: "Nieuw Wachtwoord",
    confirmPassword: "Bevestig Wachtwoord",
    newPasswordDesc: "Maak een sterk wachtwoord met minimaal 6 tekens.",
    resetPassword: "Wachtwoord Resetten",
    passwordTooShort: "Wachtwoord moet minimaal 6 tekens zijn",
    successTitle: "Wachtwoord Gewijzigd!",
    successMessage: "U kunt nu inloggen met uw nieuwe wachtwoord.",
    successSubtitle: "Uw wachtwoord is succesvol gewijzigd",
    successDesc: "Uw wachtwoord is succesvol gewijzigd. U kunt nu inloggen met uw nieuwe wachtwoord.",
    rememberPassword: "Wachtwoord onthouden?",
    step1Label: "E-mail",
    step2Label: "Verifiëren",
    step3Label: "Wachtwoord",
    passwordResetSuccess: "Uw wachtwoord is succesvol gereset",
  },
  dashboard: {
    totalApprovedDays: "Totaal Goedgekeurde Dagen",
    pendingRequests: "Wachtende Aanvragen",
    approvedRequests: "Goedgekeurde Aanvragen",
    rejectedRequests: "Afgewezen Aanvragen",
    monthlyApprovedDays: "Maandelijks Goedgekeurde Verlofdagen",
    monthlyWorkStatus: "Maandelijkse Werkstatus",
    approvedDays: "Goedgekeurde Dagen",
    working: "Gewerkt",
    halfDay: "Halve Dag",
    sick: "Ziek",
    dop: "Vrije Dag",
    onLeave: "Met Verlof",
    recentRequests: "Recente Aanvragen",
    adjustment: "aanpassing",
    statusDistribution: "Statusverdeling",
    topLeaveTypes: "Top Verlofsoorten",
    capacityHotspots: "Capaciteitshotspots",
    firmComparison: "Bedrijfsvergelijking",
    myPlanning: "Mijn Planning",
    planningLoading: "Planning laden...",
    upcomingCount: "{{count}} komende",
    historyCount: "{{count}} verleden",
    viewList: "Lijst",
    viewWeek: "Week",
    today: "Vandaag",
    noAssignmentToday: "Geen opdracht voor vandaag.",
    nextSevenDays: "Komende 7 dagen",
    historyWith: "Historiek ({{count}})",
    week: "Week",
    thisWeek: "Vandaag",
    prevWeek: "Vorige week",
    nextWeek: "Volgende week",
    weekDaysToggle: "5 of 7 dagen",
    sevenDaysShort: "7 dagen",
    fiveDaysShort: "5 dagen",
    daysShort: { 0: "Zo", 1: "Ma", 2: "Di", 3: "Wo", 4: "Do", 5: "Vr", 6: "Za" },
    monthsShort: { 0: "Jan", 1: "Feb", 2: "Mrt", 3: "Apr", 4: "Mei", 5: "Jun", 6: "Jul", 7: "Aug", 8: "Sep", 9: "Okt", 10: "Nov", 11: "Dec" },
    quickActions: "Snelle Acties",
    requests: "aanvragen",
    globalView: "Globaal Overzicht",
    allFirms: "Alle Bedrijven",
    activeEmployees: "Actieve Werknemers",
    pendingRegistrations: "Wachtende Registraties",
    todayWorking: "Vandaag Werkend",
    clickToSeeDetails: "Klik voor details",
    todayStatus: "Uw Status Vandaag",
    noStatusYet: "Nog niet ingesteld",
    createLeaveHint: "Maak snel uw verlofaanvraag aan",
    workStatusHint: "Bekijk uw dagelijkse werkstatus",
    myRecentRequests: "Mijn Recente Aanvragen",
    lastFiveRequests: "Uw laatste 5 aanvragen",
    viewAll: "Alles Bekijken",
    vehicleWarnings: "Voertuigwaarschuwingen",
    critical: "Kritiek",
    warning: "Waarschuwing",
    viewAllVehicles: "Alles Bekijken",
    andMoreVehicles: "en {{count}} meer voertuigen...",
    andMorePeople: "en {{count}} meer personen... Alles Bekijken",
    allDocsUpToDate: "Alle documenten zijn actueel",
    noExpiringDocs: "Geen documenten die binnen 90 dagen verlopen.",
    expiryAlertSent: "Documentvervalmeldingen verzonden naar {count} personen.",
    noExpiryAlertNeeded: "Geen personen gevonden om te melden.",
    sendAlert: "Melding Versturen",
    sendAlertError: "Kon geen melding versturen",
    checking: "Controleren...",
    checkExpiryTooltip: "Controleer op verlopende documenten en verstuur meldingen",
    todos: "Taken",
    noTodos: "Geen open taken.",
    markDone: "Voltooi",
    lastCheck: "Laatste controle",
    expired: "Verlopen",
    criticalDays: "Kritiek (30 dagen)",
    warningDays: "Waarschuwing (90 dagen)",
    totalPeople: "Totaal: {count} personen",
    insuranceExpired: "Verzekering {days} dagen geleden verlopen!",
    insuranceExpiring: "Verzekering verloopt over {days} dagen",
    inspectionExpired: "Keuring {days} dagen geleden verlopen!",
    inspectionExpiring: "Keuring verloopt over {days} dagen",
    maintenanceOverdue: "Onderhoud {days} dagen te laat!",
    maintenanceUpcoming: "Onderhoud over {days} dagen",
  },
  months: {
    jan: "Jan",
    feb: "Feb",
    mar: "Mrt",
    apr: "Apr",
    may: "Mei",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Okt",
    nov: "Nov",
    dec: "Dec",
  },
  auth: {
    email: "E-mail",
    password: "Wachtwoord",
    passwordConfirm: "Bevestig Wachtwoord",
    fullName: "Volledige Naam",
    gsm: "Telefoon",
    language: "Taal",
    loginTitle: "Log in op uw account",
    registerTitle: "Maak een nieuw account aan",
    registerRightTitle: "Sluit u aan bij onze gemeenschap",
    registerRightDesc: "Maak uw account aan en begin met het efficiënt beheren van verlofaanvragen.",
    registerSuccessTitle: "Registratie Succesvol!",
    registerSuccessMsg: "Uw account is aangemaakt. U kunt inloggen na goedkeuring door de beheerder.",
    pendingApproval: "Uw account wacht op goedkeuring. Wacht op bevestiging van de beheerder.",
    forgotPassword: "Wachtwoord Vergeten",
    noAccount: "Heeft u geen account?",
    hasAccount: "Heeft u al een account?",
    welcomeBack: "Log in op uw account",
    loginSuccess: "Inloggen succesvol",
    rememberMe: "Onthoud mij",
    biometricLogin: "Biometrische Login",
    biometricNotRegistered: "Geen biometrische inloggegevens gevonden op dit apparaat",
    orBiometric: "of",
    registerSuccess: "Registratie succesvol. Uw account wacht op goedkeuring.",
    invalidCredentials: "Ongeldig e-mailadres of wachtwoord",
    accountPending: "Uw account wacht op goedkeuring. Wacht op bevestiging van de beheerder.",
    accountRejected: "Uw account is afgewezen.",
    invalidResetLink: "Ongeldige wachtwoord reset link",
    invalidLink: "Ongeldige Link",
    setNewPassword: "Nieuw Wachtwoord Instellen",
    setNewPasswordDescription: "Stel een nieuw wachtwoord in voor uw account",
    newPassword: "Nieuw Wachtwoord",
    confirmNewPassword: "Bevestig Nieuw Wachtwoord",
    passwordMinLength: "Wachtwoord moet minimaal 6 tekens bevatten",
    passwordsDoNotMatch: "Wachtwoorden komen niet overeen",
    passwordResetSuccess: "Wachtwoord succesvol gewijzigd",
    passwordChanged: "Wachtwoord Gewijzigd",
    passwordResetSuccessMessage: "Uw wachtwoord is succesvol gewijzigd. U kunt nu inloggen met uw nieuwe wachtwoord.",
    setPassword: "Wachtwoord Instellen",
    backToLogin: "Terug naar inloggen",
    twoFA: "Tweefactorauthenticatie (2FA)",
    twoFAVerification: "2FA Verificatie",
    twoFASetup: "2FA Instellen",
    twoFAEnabled: "2FA Actief",
    twoFADisabled: "2FA Inactief",
    twoFAActive: "Actief",
    twoFAInactive: "Inactief",
    twoFAProtected: "Uw account is beschermd met tweefactorauthenticatie",
    twoFAEncourage: "Schakel 2FA in om uw account veiliger te maken",
    twoFASupportedApps: "Google Authenticator, Microsoft Authenticator, Authy en andere TOTP-apps worden ondersteund",
    twoFAEnable: "2FA Inschakelen",
    twoFADisable: "2FA Uitschakelen",
    twoFABackupCodes: "Back-upcodes",
    twoFAYourBackupCodes: "Uw Back-upcodes",
    twoFAScanQR: "Scan de onderstaande QR-code met uw authenticator-app:",
    twoFACantScanQR: "Kunt u de QR-code niet scannen?",
    twoFAScannedNext: "Ik heb gescand, ga verder",
    twoFAEnterCode: "Voer de 6-cijferige code in van uw authenticator-app:",
    twoFAVerifyAndEnable: "Verifiëren en Inschakelen",
    twoFASaveBackupCodes: "Bewaar deze back-upcodes op een veilige plaats. U kunt ze gebruiken om in te loggen als u geen toegang heeft tot uw authenticator-app.",
    twoFACopyCodes: "Codes Kopiëren",
    twoFAComplete: "Gereed",
    twoFADisableConfirm: "Voer uw wachtwoord in om 2FA uit te schakelen:",
    twoFAYourPassword: "Uw wachtwoord",
    twoFACancel: "Annuleren",
    twoFARemainingCodes: "Resterend: {count} codes",
    twoFACopy: "Kopiëren",
    twoFARegenerate: "Vernieuwen",
    twoFACopied: "Gekopieerd!",
    twoFALoginPrompt: "voer de 6-cijferige code in van uw authenticator-app",
    twoFALoginBackupPrompt: "voer uw back-upcode in",
    twoFAUseBackupCode: "Back-upcode gebruiken",
    twoFAUseAuthCode: "Authenticator-code gebruiken",
    twoFABackToLogin: "Terug naar inloggen",
    twoFASecureConnection: "Beveiligde verbinding tot stand gebracht",
    accountCreated: "Uw account is succesvol aangemaakt.",
    firmAssignmentPending: "Na de bedrijfstoewijzing wordt uw account goedgekeurd.",
    loginAfterApproval: "Inloggen is niet mogelijk totdat het goedkeuringsproces is voltooid.",
    registrationPending: "Registratie in behandeling",
    waitingApproval: "Wachten op goedkeuring",
    step1: "Stap 1",
    step2: "Stap 2",
  },
  leave: {
    annual: "Jaarlijks Verlof",
    sick: "Ziekteverlof",
    personal: "Persoonlijk Verlof",
    paternity: "Vaderschapsverlof",
    kleinVerlet: "Klein Verzuim",
    unpaid: "Onbetaald Verlof",
    total: "Totaal",
    used: "Gebruikt",
    remaining: "Resterend",
    entitled: "Recht op",
    request: "Verlofaanvraag",
    requests: "Verlofaanvragen",
    newRequest: "Nieuwe Aanvraag",
    balances: "Verlofsaldi",
    days: "dagen",
    day: "dag",
    selectYear: "Selecteer Jaar",
    noBalances: "Geen verlofsaldi gevonden",
    adjustBalance: "Saldo Aanpassen",
    adjustmentReason: "Aanpassingsreden",
    addDays: "Dagen Toevoegen",
    removeDays: "Dagen Verwijderen",
    adjustmentHistory: "Aanpassingsgeschiedenis",
    requiresDocument: "Document Vereist",
    leaveTypes: "Verlofsoorten",
    viewBalances: "Saldi Bekijken",
    previousYears: "Vorige Jaren",
    createRequest: "Verlofaanvraag Maken",
    selectType: "Selecteer Verlofsoort",
    type: "Verlofsoort",
    selectDates: "Selecteer Datums",
    reviewSubmit: "Controleren & Verzenden",
    startDate: "Startdatum",
    endDate: "Einddatum",
    description: "Beschrijving",
    descriptionPlaceholder: "Voeg details toe over uw verlofaanvraag (optioneel)",
    documentUpload: "Document Uploaden",
    documentOptional: "Document uploaden is optioneel",
    documentRecommended: "Document wordt aanbevolen voor dit verloftype",
    confirmRequest: "Ik bevestig dat deze aanvraag correct is",
    submitRequest: "Aanvraag Indienen",
    requestCreated: "Verlofaanvraag succesvol aangemaakt",
    requestUpdated: "Verlofaanvraag bijgewerkt",
    requestCancelled: "Verlofaanvraag geannuleerd",
    requestDeleted: "Verlofaanvraag verwijderd",
    deleteRequest: "Aanvraag Verwijderen",
    deleteRequestConfirm: "Weet u zeker dat u deze verlofaanvraag wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
    noRequests: "U heeft nog geen verlofaanvragen",
    cancelRequest: "Aanvraag Annuleren",
    editRequest: "Aanvraag Bewerken",
    viewDetails: "Details Bekijken",
    insufficientBalance: "Onvoldoende verlofsaldo",
    datesOverlap: "Geselecteerde datums overlappen met een bestaande verlofaanvraag",
    blockedDays: "Geblokkeerde Dagen",
    blockedDaysWarning: "Geselecteerde datums bevatten volledig geboekte dagen",
    dayFullyBooked: "Deze dag is vol (5+ goedgekeurde aanvragen)",
    calendarView: "Kalenderweergave",
    selectedRange: "Geselecteerde Datums",
    pending: "In afwachting",
    approved: "Goedgekeurd",
    rejected: "Afgewezen",
    cancelled: "Geannuleerd",
    step1: "Stap 1",
    step2: "Stap 2",
    step3: "Stap 3",
    summary: "Samenvatting",
    myRequests: "Mijn Verlofaanvragen",
    archived: "Gearchiveerd",
    selectedDays: "Geselecteerde Dagen",
    selectedDates: "Geselecteerde Data",
    selected: "Geselecteerd",
    weekend: "Weekend",
    calendarTip: "Klik op de kalender om de dagen te selecteren waarop u verlof wilt nemen. Klik opnieuw om te deselecteren.",
    requestedAt: "Aanvraagdatum",
    more: "meer",
    daysAvailable: "dagen over",
    maxDays: "Max",
    maxDaysReached: "U kunt maximaal {days} dagen selecteren voor dit verloftype",
    selectLeaveTypeFirst: "Selecteer eerst verloftype",
    selectLeaveTypeFirstDesc: "U moet eerst hierboven een verloftype selecteren voordat u datums kunt selecteren",
    calendarTipShort: "Klik op dagen om te selecteren/deselecteren",
    locked: "Vergrendeld",
    noDaysSelected: "Selecteer dagen in de kalender",
    noRemainingDays: "Geen resterende dagen",
    remainingDays: "Resterende Dagen",
    requestSubmitted: "Verlofaanvraag ingediend",
    selectLeaveType: "Selecteer verloftype",
    selectDays: "Selecteer dagen",
    selectDaysHint: "Selecteer dagen in de kalender",
    selectTypeFirst: "Selecteer eerst verloftype",
    selectedType: "Geselecteerd type",
    step1Title: "Selecteer Verloftype",
    step2Title: "Selecteer Dagen",
    totalDays: "Totaal dagen",
  },
  leaveCalendar: {
    deleteLeave: "Verlof Verwijderen",
    deleteConfirmTitle: "Verlof Verwijderen",
    deleteConfirmMessage: "Weet u zeker dat u dit verlof wilt verwijderen?",
    deleteBalanceNote: "Voor goedgekeurd verlof worden de gebruikte dagen teruggezet naar het saldo.",
    confirmDelete: "Ja, Verwijderen",
    deleteSuccess: "Verlof succesvol verwijderd",
    deleteError: "Fout bij verwijderen verlof",
    balanceRestored: "{days} dagen teruggezet naar saldo",
    cannotDeletePast: "Verlof in het verleden kan niet worden verwijderd",
    removeThisDay: "Verwijder Alleen Deze Dag",
    removeDayConfirmTitle: "Deze Dag Verwijderen",
    removeDayConfirmMessage: "Weet u zeker dat u deze dag uit het verlof wilt verwijderen?",
    confirmRemoveDay: "Ja, Verwijder Dag",
    deleteEntireLeave: "Verwijder Volledig Verlof",
    dayRemovedSuccess: "{date} verwijderd uit verlof",
    removeDayError: "Fout bij verwijderen dag uit verlof",
  },
  admin: {
    userManagement: "Gebruikersbeheer",
    createUser: "Gebruiker Toevoegen",
    createUserDesc: "Voeg handmatig een nieuwe gebruiker toe aan het systeem",
    firmManagement: "Bedrijfsbeheer",
    pendingApprovals: "Wachtende Goedkeuringen",
    auditLogs: "Auditlogboeken",
    statistics: "Statistieken",
    totalUsers: "Totaal Gebruikers",
    totalFirms: "Totaal Bedrijven",
    pendingUsers: "Wachtende Gebruikers",
    activeUsers: "Actieve Gebruikers",
    approveUser: "Gebruiker Goedkeuren",
    rejectUser: "Gebruiker Afwijzen",
    rejectReason: "Reden van Afwijzing",
    selectFirm: "Selecteer Bedrijf",
    createFirm: "Nieuw Bedrijf",
    firmName: "Bedrijfsnaam",
    firmLogo: "Bedrijfslogo",
    selectRole: "Selecteer Rol",
    roleEmployee: "Werknemer",
    roleFirmAdmin: "Bedrijfsbeheerder",
    confirmApprove: "Weet u zeker dat u deze gebruiker wilt goedkeuren?",
    confirmReject: "Weet u zeker dat u deze gebruiker wilt afwijzen?",
    approveConfirmation: "Deze actie kan niet ongedaan worden gemaakt.",
    rejectConfirmation: "Deze actie kan niet ongedaan worden gemaakt.",
    firmRequired: "Bedrijfsselectie is verplicht",
    reasonRequired: "Afwijzingsreden is verplicht (minimaal 5 tekens)",
    userApproved: "Gebruiker succesvol goedgekeurd",
    userRejected: "Gebruiker afgewezen",
    pendingTab: "In afwachting",
    activeTab: "Actief",
    rejectedTab: "Afgewezen",
    createdAt: "Aangemaakt op",
    leaveRequestManagement: "Verlofbeheer",
    leaveManagement: "Verlof",
    listView: "Lijst",
    calendarView: "Kalender",
    approveRequest: "Aanvraag Goedkeuren",
    rejectRequest: "Aanvraag Afwijzen",
    cancelRequest: "Aanvraag Annuleren",
    archiveRequest: "Archiveren",
    editRequest: "Bewerken",
    confirmApproveLeave: "Weet u zeker dat u deze verlofaanvraag wilt goedkeuren?",
    confirmRejectLeave: "Weet u zeker dat u deze verlofaanvraag wilt afwijzen?",
    confirmCancelLeave: "Weet u zeker dat u deze goedgekeurde verlofaanvraag wilt annuleren?",
    confirmArchiveLeave: "Weet u zeker dat u deze verlofaanvraag wilt archiveren?",
    leaveApproved: "Verlofaanvraag goedgekeurd",
    leaveApprovedWithWarnings: "Verlof goedgekeurd met waarschuwingen (Super Admin override)",
    warn: {
      insufficientBalance: "Onvoldoende saldo: {{requested}} dagen aangevraagd, {{available}} beschikbaar",
      daysFullyBooked: "Deze dagen zijn volgeboekt (5+ goedgekeurd): {{dates}}",
      lockedDates: "Vergrendelde datums: {{dates}}",
      dateOverlap: "Data overlappen met een andere goedgekeurde aanvraag",
      noBalance: "Verlofsaldo niet gevonden",
    },
    leaveRejected: "Verlofaanvraag afgewezen",
    leaveCancelled: "Verlofaanvraag geannuleerd",
    leaveArchived: "Verlofaanvraag gearchiveerd",
    leaveUpdated: "Verlofaanvraag bijgewerkt",
    samePeriodsOnLeave: "Personeel met verlof op deze data:",
    overlappingDates: "Overlappende data",
    requester: "Aanvrager",
    leaveType: "Verlofsoort",
    dateRange: "Datumbereik",
    daysCount: "Dagen",
    requestDate: "Aanvraagdatum",
    adminNote: "Admin Notitie",
    adminNotePlaceholder: "Admin notitie (optioneel)...",
    enterReason: "Voer reden in",
    notifyUser: "Gebruiker Informeren",
    notifyBySms: "Per SMS",
    notifyByEmail: "Per E-mail",
    notifyByWhatsapp: "Per WhatsApp",
    balanceInfo: "Saldo-informatie",
    capacityWarning: "Capaciteitswaarschuwing",
    archivedTab: "Gearchiveerd",
    allRequests: "Alle Aanvragen",
    approveLeaveConfirmation: "U staat op het punt deze verlofaanvraag goed te keuren.",
    rejectReasonRequired: "Afwijzingsreden is verplicht",
    searchUsers: "Zoeken op naam, e-mail of telefoon...",
    allFirms: "Alle Bedrijven",
    firm: "Bedrijf",
    noUsersFound: "Geen gebruikers gevonden",
    viewDetails: "Details",
    fullName: "Volledige Naam",
    email: "E-mail",
    phone: "Telefoon",
    role: "Rol",
    status: "Status",
    suspended: "Geschorst",
    suspendUser: "Gebruiker Opschorten",
    activateUser: "Activeren",
    activate: "Activeren",
    suspend: "Schorsen",
    activateConfirm: "Deze gebruiker wordt geactiveerd en kan inloggen op het systeem.",
    suspendConfirm: "Deze gebruiker wordt geschorst en kan niet inloggen op het systeem.",
    userActivated: "Gebruiker geactiveerd",
    userSuspended: "Gebruiker opgeschort",
    reapprove: "Opnieuw goedkeuren",
    employee: "Werknemer",
    firmAdmin: "Bedrijfsbeheerder",
    confirmApproval: "Bevestig Goedkeuring",
    approvalSummary: "Goedkeuringssamenvatting",
    rejectionWarning: "Waarschuwing",
    rejectionMessage: "Deze gebruiker wordt afgewezen en kan niet inloggen op het systeem.",
    reason: "Reden",
    rejectReasonPlaceholder: "Leg de afwijzingsreden uit...",
    userDeleted: "Gebruiker verwijderd",
    deleteUserWarning: "Deze actie kan niet ongedaan worden gemaakt. Alle gebruikersgegevens worden verwijderd.",
    impersonate: "Inloggen als Gebruiker",
    sendPasswordReset: "Wachtwoord Reset Versturen",
    sendPasswordResetTitle: "Wachtwoord Reset E-mail Versturen",
    passwordResetSent: "Wachtwoord reset link verzonden naar {email}",
    sendEmail: "E-mail Versturen",
    setPassword: "Wachtwoord Instellen",
    setPasswordTitle: "Wachtwoord Instellen",
    newPassword: "Nieuw Wachtwoord",
    generatePassword: "Willekeurig Genereren",
    setPasswordConfirm: "Wachtwoord Opslaan",
    changeFirm: "Bedrijf Wijzigen",
    newFirm: "Nieuw Bedrijf",
    transfer: "Overdragen",
    transferSuccess: "Gebruiker succesvol overgedragen",
    selectDifferentFirm: "Selecteer een ander bedrijf",
    firmTransferWarning: "Deze actie heeft geen invloed op het verlofsaldo van de gebruiker.",
    changeRole: "Rol Wijzigen",
    pagePermissions: "Paginamachtigingen",
    allowedFirms: "Toegestane Bedrijven",
    allowedFirmsDesc: "Laat leeg om geen bedrijftoegang te verlenen",
    pageAccess: "Paginatoegang",
    pageAccessDesc: "Leeg laten om alle pagina's toe te staan",
    additionalPermissions: "Extra Machtigingen",
    canDelete: "Verwijderrechten",
    canDeleteDesc: "Kan records verwijderen",
    canViewFinancial: "Financiële Records Bekijken",
    canViewFinancialDesc: "Kan financiële invoer en voorschotsecties bekijken",
    canSendNotifications: "Meldingen Verzenden",
    canSendNotificationsDesc: "Kan meldingen naar gebruikers verzenden",
    newRole: "Nieuwe Rol",
    changeRoleBtn: "Rol Wijzigen",
    roleChanged: "Gebruikersrol gewijzigd",
    selectDifferentRole: "Selecteer een andere rol",
    firmAdminWarning: "Bedrijfsbeheerder kan gebruikers en verlofaanvragen in hun bedrijf beheren.",
    export: "Exporteren",
    import: "Importeren",
    importUsers: "Gebruikers Importeren",
    exportSuccess: "Gebruikers geëxporteerd",
    importSuccess: "Gebruikers geïmporteerd",
    importAndUpdate: "Importeren en Bijwerken",
    importPreview: "Voorbeeld",
    importResults: "Resultaten",
    created: "Aangemaakt",
    updated: "Bijgewerkt",
    skipped: "Overgeslagen",
    errors: "Fouten",
    impersonateAs: "bekijkt als",
    returnToAdmin: "terug naar account",
    confirmDeleteLeaveRequest: "Weet u zeker dat u dit verlofverzoek permanent wilt verwijderen?",
    confirmDeleteUser: "Weet u zeker dat u deze gebruiker wilt verwijderen?",
    deleteLeaveRequest: "Verlofverzoek Verwijderen",
    deleteLeaveRequestSuccess: "Verlofverzoek verwijderd",
    deleteUser: "Gebruiker Verwijderen",
    deleteUserDesc: "Deze actie kan niet ongedaan worden gemaakt. De gebruiker en alle gerelateerde gegevens worden verwijderd.",
    deleteUserSuccess: "Gebruiker verwijderd",
    enterPanel: "Paneel Openen",
    fullAdminWarning: "Volledige beheerder kan gebruikers en verlofaanvragen beheren voor toegewezen bedrijven.",
    leaveRequestDeleted: "Verlofverzoek permanent verwijderd",
    hardDelete: "Hard Verwijderen",
    hardDeleteTitle: "Hard Verwijderen (Super Admin)",
    hardDeleteWarning: "Dit overschrijft ALLE validaties en verwijdert het verlofrecord permanent. Saldo wordt NIET hersteld. Ook oude records kunnen worden verwijderd.",
    hardDeleteConfirmPrompt: "Typ HARDSIL in hoofdletters om te bevestigen:",
    hardDeleteConfirmWord: "HARDSIL",
    hardDeleteConfirmButton: "Ja, Forceer Verwijderen",
    hardDeleteSuccess: "Verlofverzoek hard verwijderd",
    hardDeleteTooltip: "Hard Verwijderen: alle regels omzeilen (Alleen Super Admin)",
    loginAs: "Inloggen als",
    permissionsSaved: "Machtigingen opgeslagen",
    resetPassword: "Wachtwoord Resetten",
    sendResetPassword: "Wachtwoord Reset Verzenden",
    suspendUserDesc: "Opgeschorte gebruikers kunnen niet inloggen op het systeem.",
    unsuspendUser: "Gebruiker Activeren",
    updatePermissions: "Machtigingen Bijwerken",
    userDetails: "Gebruikersdetails",
    userUnsuspended: "Gebruiker geactiveerd",
    deleteWarning: "Deze actie kan niet ongedaan worden gemaakt!",
    enableLandingPage: "Landingspagina Inschakelen",
    frontendSettings: "Frontend Instellingen",
    frontendSettingsDescription: "Pas het uiterlijk van de frontend aan",
    landingDisabledWarning: "Landingspagina uitgeschakeld",
    landingPageImage: "Landingspagina Afbeelding",
    landingPageNote: "Landingspagina opmerking",
    landingPageToggle: "Landingspagina",
    landingPageToggleDesc: "Landingspagina tonen/verbergen",
    loginPageImage: "Inlogpagina Afbeelding",
    pageImages: "Pagina Afbeeldingen",
    pageImagesDesc: "Beheer afbeeldingen van inlog- en registratiepagina",
    registerPageImage: "Registratiepagina Afbeelding",
    settingsSaved: "Instellingen opgeslagen",
    siteName: "Sitenaam",
    siteNameDesc: "Wijzig de weergegeven applicatienaam",
    siteNameHelp: "Deze naam verschijnt in browsertab en inlogpagina",
    siteNameLabel: "Sitenaam",
    superAdminRequired: "Super Admin toestemming vereist",
    confirmRejection: "Weet u zeker dat u wilt afwijzen?",
  },
  login: {
    heroTitle: "Beheer het verlof van uw team efficiënt",
    heroDescription: "Stroomlijn verlofaanvragen, goedkeuringen en tracking op één plek.",
  },
  landing: {
    heroTitle: "Volgende Generatie Verlofbeheer",
    heroSubtitle: "Beheer, keur en volg de verlofaanvragen van uw medewerkers eenvoudig digitaal.",
    getStarted: "Aan de slag",
    learnMore: "Meer informatie",
    features: "Functies",
    feature1Title: "Eenvoudig Verlof Bijhouden",
    feature1Desc: "Volg jaarlijks, ziekte- en persoonlijk verlof vanuit één dashboard.",
    feature2Title: "Snel Goedkeuringsproces",
    feature2Desc: "Managers kunnen verlofaanvragen direct goedkeuren of afwijzen.",
    feature3Title: "Multi-Tenant Ondersteuning",
    feature3Desc: "Beheer meerdere bedrijven vanuit één platform.",
  },
  validation: {
    required: "Dit veld is verplicht",
    invalidEmail: "Voer een geldig e-mailadres in",
    passwordMin: "Wachtwoord moet minimaal 6 tekens bevatten",
    passwordMatch: "Wachtwoorden komen niet overeen",
    phoneFormat: "Voer een geldig telefoonnummer in",
  },
  profile: {
    changePassword: "Wachtwoord Wijzigen",
    confirmNewPassword: "Bevestig Nieuw Wachtwoord",
    currentPassword: "Huidig Wachtwoord",
    incorrectPassword: "Huidig wachtwoord is onjuist",
    languageSettings: "Taalinstellingen",
    lastLogin: "Laatste Login",
    memberSince: "Lid Sinds",
    newPassword: "Nieuw Wachtwoord",
    passwordChanged: "Wachtwoord gewijzigd",
    passwordMismatch: "Wachtwoorden komen niet overeen",
    accountActive: "Uw account is actief",
    accountInactive: "Uw account is inactief",
    accountInfo: "Accountinformatie",
    accountRejected: "Uw account is afgewezen",
    accountStatus: "Accountstatus",
    company: "Bedrijf",
    darkMode: "Donkere Modus",
    email: "E-mail",
    fullName: "Volledige Naam",
    language: "Taal",
    phone: "Telefoon",
    phoneNumber: "Telefoonnummer",
    role: "Rol",
    settings: "Instellingen",
    theme: "Thema",
    waitingApproval: "Wachten op goedkeuring",
  },
  calendar: {
    title: "Verlofkalender",
    description: "Kalenderweergave van goedgekeurde verloven",
    monthly: "Maandelijks",
    weekly: "Wekelijks",
    today: "Vandaag",
    employeesOnLeave: "Medewerkers met Verlof",
    totalLeaveDays: "Totaal Verlofdagen",
    approvedLeaves: "Goedgekeurde Verloven",
    monday: "Ma",
    tuesday: "Di",
    wednesday: "Wo",
    thursday: "Do",
    friday: "Vr",
    saturday: "Za",
    sunday: "Zo",
  },
  leaveTypes: {
    title: "Verloftypes",
    description: "Beheer verloftypes in het systeem",
    add: "Nieuw Verloftype",
    total: "Totaal",
    active: "Actief",
    inactive: "Inactief",
    code: "Code",
    name: "Naam",
    defaultDays: "Standaard Dagen",
    defaultLabel: "Standaard",
    requiresDocument: "Document Vereist",
    status: "Status",
    isActive: "Actief",
    createTitle: "Nieuw Verloftype Aanmaken",
    createDescription: "Definieer een nieuw verloftype voor het systeem",
    editTitle: "Verloftype Bewerken",
    edit: "Bewerken",
    deleteTitle: "Verloftype Verwijderen",
    created: "Verloftype aangemaakt",
    updated: "Verloftype bijgewerkt",
    deleted: "Verloftype verwijderd",
    activated: "Verloftype geactiveerd",
    deactivated: "Verloftype gedeactiveerd",
    codeAndNameRequired: "Code en naam zijn verplicht",
    noData: "Nog geen verloftypes gedefinieerd",
    viewUsers: "Gebruikers",
    usersWithType: "Gebruikers met dit Verloftype",
    totalBalances: "Totaal Saldo",
    totalRequests: "Totale Aanvragen",
    noUsersWithType: "Niemand gebruikt dit verloftype",
    canSafelyDelete: "U kunt dit verloftype veilig verwijderen",
    balanceRemoved: "Saldo verwijderd",
    removeBalance: "Saldo Verwijderen",
    cannotRemoveWithRequests: "Kan saldo niet verwijderen voor gebruikers met verlofaanvragen",
    warningRequestsExist: "Er zijn verlofaanvragen voor dit type. Verwijder eerst de saldo's.",
    adminOnly: "Alleen Admin",
    adminOnlyDesc: "Gebruikers kunnen dit type niet zien in hun verlofaanvragen",
    yes: "Ja",
    no: "Nee",
    days: "dagen",
    orphanBalance: "Wees Saldo",
    duplicateCheck: "Dubbele Controle",
    color: "Kleur",
    onlyUppercaseAndUnderscore: "Alleen hoofdletters en underscore",
    daysCountChanged: "Aantal dagen gewijzigd",
  },
  customers: {
    title: "Klantbeheer",
    description: "Beheer route formuliervelden per klant",
    newCustomer: "Nieuwe Klant Aanmaken",
    editCustomer: "{{name}} Bewerken",
    name: "Klantnaam",
    nameRequired: "Klantnaam is verplicht",
    slug: "Slug (Unieke Code)",
    calculationType: "Berekeningstype",
    fields: "Velden",
    created: "Klant aangemaakt",
    updated: "Klant bijgewerkt",
    deleted: "Klant verwijderd",
    save: "Opslaan",
    cancel: "Annuleren",
    delete: "Verwijderen",
    edit: "Bewerken",
    addButton: "Nieuwe Klant",
    system: "Systeem",
    custom: "Aangepast",
    noCustomers: "Nog geen klanten gedefinieerd",
    deleteTitle: "Klant Verwijderen",
    deleteMessage: "Weet u zeker dat u {{name}} wilt verwijderen?",
    atLeastOneField: "U moet minimaal één veld selecteren",
    operationFailed: "Bewerking mislukt",
    cannotDelete: "Kan niet verwijderen",
    deleteFailed: "Verwijdering mislukt",
    errorOccurred: "Er is een fout opgetreden",
    calculationMethod: "Berekeningsmethode",
    formFields: "Formuliervelden",
    fieldsSelected: "velden geselecteerd",
    defaultValue: "Standaard",
    preview: "Voorbeeld",
    calculation: "Berekening",
    update: "Bijwerken",
    create: "Aanmaken",
    example: "Bv",
    defaultsCreated: "Standaard klanten aangemaakt",
    namePlaceholder: "Klantnaam",
    slugPlaceholder: "klant_slug",
    categoryBase: "Basisvelden",
    categoryIdentity: "Identificatie / Nummer",
    categoryPersonnel: "Personeel",
    categoryDistance: "Afstand",
    categoryPricing: "Prijsstelling",
    categoryTime: "Tijd",
    color: "Kleur",
  },
  vehicles: {
    title: "Mijn Voertuigen",
    detail: "Voertuig Detail",
    generalInfo: "Algemene Informatie",
    technicalInfo: "Technische Informatie",
    ownershipSale: "Eigendom & Verkoop",
    notes: "Notities",
    noNotes: "Geen notities",
    documents: "Documenten",
    photos: "Foto's",
    maintenanceInsurance: "Onderhoud & Verzekering",
    insurance: "Verzekering",
    inspection: "Keuring",
    maintenance: "Onderhoud",
    activeWarnings: "Actieve Waarschuwingen",
    edit: "Bewerken",
    save: "Opslaan",
    cancelEdit: "Annuleren",
    uploadDoc: "Uploaden",
    uploadPhoto: "Foto Uploaden",
    dragDropDocs: "Sleep bestanden hierheen",
    dragDropPhotos: "Sleep foto's hierheen",
    orUseButton: "of gebruik de upload knop",
    subtitle: "Beheer bedrijfsvoertuigen",
    sendReminder: "Herinnering Sturen",
    excelUpload: "Excel Uploaden",
    newVehicle: "Nieuw Voertuig",
    searchLabel: "Zoeken",
    searchPlaceholder: "Kenteken, merk, model, bedrijf...",
    fuelTypeFilter: "Brandstoftype",
    statusFilter: "Status",
    all: "Alle",
    ok: "OK",
    warningStatus: "Waarschuwing",
    criticalStatus: "Kritiek",
    totalVehicles: "Totaal Voertuigen",
    firmCount: "Aantal Bedrijven",
    hasWarnings: "Waarschuwingen",
    hasCritical: "Kritiek",
    brandDistribution: "Merkverdeling",
    fuelDistribution: "Brandstofverdeling",
    unknownBrand: "Onbekend",
    notSpecified: "Niet opgegeven",
    noDataFound: "Geen gegevens gevonden",
    vehicleList: "Voertuiglijst",
    vehicleCount: "voertuigen",
    totalLabel: "totaal",
    hideChart: "Grafiek Verbergen",
    showBrandChart: "Merkgrafiek",
    selectedCount: "voertuigen geselecteerd",
    deleteSelected: "Selectie Verwijderen",
    noVehicles: "Geen voertuigen gevonden",
    addFirst: "Eerste Voertuig Toevoegen",
    editVehicle: "Voertuig Bewerken",
    addVehicle: "Nieuw Voertuig Toevoegen",
    plateRequired: "Kenteken is verplicht",
    firmRequired: "Bedrijfsselectie is verplicht",
    vehicleUpdated: "Voertuig bijgewerkt",
    vehicleAdded: "Voertuig toegevoegd",
    vehicleDeleted: "Voertuig verwijderd",
    deleteError: "Verwijderingsfout",
    importError: "Importfout",
    notificationFailed: "Melding kon niet worden verzonden",
    bulkDeleteError: "Bulk verwijderingsfout",
    errorOccurred: "Er is een fout opgetreden",
    selectFirm: "Selecteer bedrijf",
    platePlaceholder: "Bv: 1-ABC-123",
    brandPlaceholder: "Bv: Ford",
    modelPlaceholder: "Bv: Transit",
    yearPlaceholder: "Bv: 2023",
    selectColor: "Selecteer kleur",
    vehicleDetailsSection: "Voertuigdetails",
    chassisPlaceholder: "Chassisnummer",
    loadPlaceholder: "Bv: 1162 KG",
    fuelSelectLabel: "Brandstoftype",
    permitPlaceholder: "Vergunningnummer",
    ownershipPlaceholder: "Eigendomstype",
    purchasePlaceholder: "Aankooplocatie",
    insuranceCompanyLabel: "Verzekeringsmaatschappij",
    maintenanceTracking: "Onderhoud & Verzekeringsopvolging",
    insuranceExpiryDate: "Verzekering Vervaldatum",
    inspectionExpiryDate: "Keuring Vervaldatum",
    lastMaintenanceDate: "Laatste Onderhoudsdatum",
    nextMaintenanceDate: "Volgende Onderhoudsdatum",
    lastMaintenanceKmLabel: "Laatste Onderhoud KM",
    nextMaintenanceKmLabel: "Volgende Onderhoud KM",
    notesLabel: "Notities",
    notesPlaceholder: "Extra informatie...",
    selectOption: "Selecteer",
    maintenanceKmPlaceholder: "Bv: 50000",
    nextMaintenanceKmPlaceholder: "Bv: 60000",
    ruhsatInVehicle: "In voertuig",
    ruhsatOutVehicle: "Buiten voertuig",
    tableStatus: "Status",
    tablePlate: "Kenteken",
    tableBrandModel: "Merk / Model",
    tableYear: "Jaar",
    tableFuel: "Brandstof",
    tableOwnership: "Eigendom",
    tableInsurance: "Verzekering",
    tableInspection: "Keuring",
    tableNextMaintenance: "Volgend Onderhoud",
    tableFirm: "Bedrijf",
    documentsTitle: "Documenten",
    vehicleDetailTitle: "Voertuig Detail",
    deleteVehicleTitle: "Voertuig Verwijderen",
    deleteVehicleConfirm: "Weet u zeker dat u het voertuig met kenteken wilt verwijderen?",
    bulkDeleteTitle: "Bulk Voertuig Verwijderen",
    bulkDeleteMessage: "voertuigen worden verwijderd. Deze actie kan niet ongedaan worden gemaakt.",
    deleteCountBtn: "Voertuigen Verwijderen",
    buildYear: "Bouwjaar",
    showSold: "Verkochte tonen",
    resetFilters: "Reset",
    vehicleLoadError: "Voertuig kon niet geladen worden",
    saved: "Opgeslagen",
    saveError: "Opslagfout",
    docUploaded: "{{count}} document(en) geüpload",
    uploadError: "Uploadfout",
    docDeleted: "Document verwijderd",
    updateError: "Bijwerkfout",
    photoUploaded: "{{count}} foto('s) geüpload",
    photoDeleted: "Foto verwijderd",
    previewError: "Voorbeeld kon niet geladen worden",
    pdfLoadError: "PDF kon niet geladen worden",
    loadingPreview: "Laden...",
    sold: "VERKOCHT",
    ownershipType: "Lease / Eigendom",
    plate: "Kenteken",
    brand: "Merk",
    model: "Model",
    color: "Kleur",
    firm: "Bedrijf",
    chassisNumber: "Chassisnummer",
    loadCapacity: "Laadvermogen",
    fuelType: "Brandstof",
    permitNumber: "Vergunningnummer",
    sticker: "Sticker",
    insuranceCompany: "Verzekeringsmaatschappij",
    expiryDate: "Vervaldatum",
    lastMaintenance: "Laatste Onderhoud",
    nextMaintenance: "Volgend Onderhoud",
    lastMaintenanceKm: "Laatste Onderhoud KM",
    nextMaintenanceKm: "Volgend Onderhoud KM",
    purchaseLocation: "Aankooplocatie",
    purchaseDate: "Aankoopdatum",
    saleDate: "Verkoopdatum",
    keuring: "Keuring",
    ruhsat: "Inschrijvingsbewijs (Kentekenbewijs)",
    vergunning: "Vergunning",
    sigortaPolicesi: "Verzekeringspolis",
    muayeneRaporu: "Keuringsrapport",
    bakimRaporu: "Onderhoudsrapport",
  },
  dailyStatus: {
    title: "Dagelijkse Werknemersstatus",
    description: "Volg de dagelijkse status van werknemers",
    today: "Vandaag",
    status: "Status",
    selectStatus: "Selecteer Status",
    legend: "Statuslegenda",
    noUsers: "Geen gebruikers gevonden",
    updatedBy: "Bijgewerkt door",
    working: "Gewerkt",
    halfDay: "Halve Dag",
    sick: "Ziek",
    dop: "Vrije Dag",
    onLeave: "Met Verlof",
    paternity: "Vaderschapsverlof",
    notSet: "Niet Ingesteld",
    cancel: "Annuleren",
    goToPage: "Bekijk Alle Statussen",
    clickToApplyAll: "Klik om op iedereen toe te passen",
    setAllTo: "Stel alles in op {status}",
    clearAllStatuses: "Wis alle statussen",
    updatingAll: "Alle gebruikers worden bijgewerkt...",
    bulkUpdateTitle: "Bulk Statuswijziging",
    bulkUpdateConfirm: "Weet u zeker dat u de status van alle medewerkers wilt wijzigen naar \"{status}\"?",
    usersWillBeUpdated: "gebruikers worden bijgewerkt",
    filteredUsers: "Zoekfilter toegepast",
    applyToAll: "Toepassen op Alles",
    bulkUpdateSuccess: "{count} gebruikers status bijgewerkt",
    bulkUpdateError: "{count} gebruikers konden niet worden bijgewerkt",
    allUsersAlreadyHaveStatus: "Alle gebruikers hebben al deze status",
    daySummary: "Dag Samenvatting",
    showEmployees: "Toon Medewerkers",
    hideEmployees: "Verberg Medewerkers",
    quickEditMode: "Snelle Markering Modus",
    quickEditActive: "geselecteerd - Klik op cellen om snel te markeren",
    clickAgainToClear: "Klik nogmaals om te wissen",
    clickStatusToActivate: "Selecteer een status om snel te markeren",
    tapCellToApply: "Tik op cel",
    clickCellToApply: "Klik op een cel om status toe te passen • Nogmaals klikken om te wissen",
    switchTo: "Wissel:",
    exitQuickEdit: "Sluiten",
    overwriteConfirmTitle: "Bestaande Status Wordt Gewijzigd",
    overwriteConfirmDesc: "Deze cel heeft al een status. Wilt u het wijzigen?",
    currentStatus: "Huidige Status",
    newStatus: "Nieuwe Status",
    confirmOverwrite: "Ja, Wijzigen",
    allUsersHaveStatus: "Alle gebruikers hebben al een status",
    skippedExisting: "bestaande status overgeslagen",
    willBeUpdated: "Wordt Bijgewerkt",
    willBeSkipped: "Wordt Overgeslagen",
    existingStatusesProtected: "Bestaande statussen blijven behouden",
    employeesUpdated: "medewerkers bijgewerkt",
    statusUpdated: "Status bijgewerkt",
    noChanges: "Geen wijzigingen",
    changesSaved: "Wijzigingen opgeslagen",
    selectedEmployees: "medewerkers geselecteerd",
    allEmployees: "alle medewerkers",
    bulkWarning: "Status wordt bijgewerkt voor alle medewerkers",
    cannotEditPastDates: "U kunt geen data in het verleden bewerken",
    syncLeaves: "Verloven Synchroniseren",
    syncLeavesTitle: "Verlof Synchronisatie",
    syncLeavesDesc: "Goedgekeurde verloven synchroniseren met dagelijkse status",
    syncEmployees: "medewerkers met",
    syncMissingDays: "ontbrekende dagen gevonden",
    missingDayCount: "ontbrekende dagen",
    syncUser: "Synchroniseren",
    syncAll: "Alles Synchroniseren",
    allSynced: "Alle verloven gesynchroniseerd!",
    noMissingDays: "Geen ontbrekende dagen gevonden.",
    day: "dagen",
    confirmPastEdit: "Ja, Bewerken",
    externalFirm: "Extern Bedrijf",
    pastDateConfirmMessage: "U staat op het punt om de werknemersstatus op een verleden datum te wijzigen. Doorgaan?",
    pastDateConfirmTitle: "Verleden datum bewerken?",
    showOnlyWorking: "Alleen Werkend",
    todayShort: "Vandaag",
    weekViewLabel: "Week",
    noPastEditPermission: "Geen toestemming om verleden datums te bewerken",
    pastDateConfirmNote: "Dit beïnvloedt vergrendelde datums niet",
    pastDateWarning: "Verleden datum wordt bewerkt",
    pendingChanges: "Er zijn openstaande wijzigingen",
    selectExternalFirm: "Selecteer extern bedrijf",
    willShowAs: "wordt weergegeven als",
  },
  leaveRequestsAdmin: {
    addForUser: "Verlof Toevoegen voor Gebruiker",
    addForUserDesc: "Maak een verlofaanvraag namens een gebruiker",
    autoApprove: "Automatisch Goedkeuren",
    autoApproveDesc: "Verlofaanvraag wordt onmiddellijk goedgekeurd en afgetrokken van saldo",
    createAndApprove: "Aanmaken en Goedkeuren",
    createdAndApproved: "Verlofaanvraag aangemaakt en goedgekeurd",
    created: "Verlofaanvraag aangemaakt",
    fillRequired: "Vul alle verplichte velden in",
    selectUser: "Selecteer Gebruiker",
    create: "Aanmaken",
  },
  myFinance: {
    title: "Mijn Financiën",
    subtitle: "Voorschotten, POT, laadvergoeding en andere records",
    hiddenTitle: "Financiële gegevens momenteel verborgen",
    hiddenDesc: "Uw firmabeheerder heeft de zichtbaarheid van financiële werknemersgegevens uitgeschakeld. Neem contact op met uw beheerder.",
    savePdf: "Opslaan als PDF",
  },
  workStats: {
    myStatistics: "Mijn Werkstatistieken",
    myStatisticsDesc: "Jaarlijks werkstatus overzicht",
    adminStatistics: "Werkstatistieken",
    employeeStatistics: "Werknemerstatistieken",
    adminStatisticsDesc: "Alle werknemers status statistieken",
    monthlyBreakdown: "Maandelijks Overzicht",
    statusDistribution: "Status Verdeling",
    calendarView: "Kalender Weergave",
    employeeBreakdown: "Werknemer Overzicht",
    yearSummary: "Jaar Samenvatting",
    periodSummary: "Periode Samenvatting",
    totalRecords: "totaal van",
    daysRecorded: "dagen geregistreerd",
    periodTotal: "periode totaal van",
    recordsFound: "records gevonden",
    employeesTracked: "werknemers gevolgd",
    quickRange: "Snelle Selectie",
    today: "Vandaag",
    yesterday: "Gisteren",
    thisWeek: "Deze Week",
    lastWeek: "Vorige Week",
    thisMonth: "Deze Maand",
    thisQuarter: "Dit Kwartaal",
    thisYear: "Dit Jaar",
    dateRange: "Datumbereik",
    year: "Jaar",
    startDate: "Startdatum",
    endDate: "Einddatum",
    exportExcel: "Excel Downloaden",
    exportSuccess: "Excel bestand gedownload",
    externalFirm: "Extern Bedrijf",
    lastMonth: "Vorige Maand",
  },
  notifications: {
    title: "Meldingen",
    subtitle: "Beheer SMS, E-mail en WhatsApp meldingsinstellingen",
    settings: "Instellingen",
    outbox: "Verzendbox",
    enabled: "Ingeschakeld",
    disabled: "Uitgeschakeld",
    channel: "Kanaal",
    event: "Gebeurtenis",
    recipient: "Ontvanger",
    status: "Status",
    attempts: "Pogingen",
    message: "Bericht",
    details: "Details",
    lastError: "Laatste Fout",
    settingsSaved: "Meldingsinstellingen opgeslagen",
    testSend: "Test Verzenden",
    testDescription: "Stuur een testmelding voor dit kanaal",
    testSent: "Testmelding verzonden",
    retryQueued: "In wachtrij voor opnieuw proberen",
    send: "Verzenden",
    providerUrl: "Provider URL",
    apiKey: "API Sleutel",
    sender: "Afzender",
    timeout: "Time-out (ms)",
    smtpHost: "SMTP Server",
    smtpPort: "SMTP Poort",
    smtpUser: "SMTP Gebruiker",
    smtpPass: "SMTP Wachtwoord",
    fromAddress: "Van Adres",
    emailAddress: "E-mailadres",
    phoneNumber: "Telefoonnummer",
    emailProvider: "E-mailprovider",
    mandrillApiKey: "Mandrill API Sleutel",
    fromName: "Van Naam",
    replyTo: "Antwoord Aan",
    smsApiNote: "API wordt aangeroepen met gsm, mesaj, mesajturu parameters",
    defaultMesajTuru: "Standaard Berichttype",
    retry: "Opnieuw Proberen",
    retryWithReset: "Opnieuw Proberen met Reset",
    confirmDelete: "Weet u zeker dat u deze melding wilt verwijderen?",
    deleted: "Melding verwijderd",
    selectToDelete: "Selecteer meldingen om te verwijderen",
  },
  employeeProfile: {
    title: "Werknemersprofielen",
    myProfile: "Mijn Profiel",
    personalInfo: "Persoonlijke Informatie",
    documents: "Documenten",
    history: "Verlof & Werkgeschiedenis",
    finance: "Financiën & Statistieken",
    profileCompletion: "Profiel Voltooiing",
    complete: "Volledig",
    incomplete: "Onvolledig",
    saveProfile: "Opslaan",
    uploadDocument: "Document Uploaden",
    addFinanceEntry: "Financiële Record Toevoegen",
    type: "Type",
    myDocuments: "Mijn Documenten",
    employeeDocuments: "Werknemer Documenten",
    documentsOf: "Documenten van",
    firstName: "Voornaam",
    lastName: "Naam (Achternaam)",
    birthDate: "Geboortedatum",
    birthPlace: "Geboorteplaats",
    nationality: "Nationaliteit",
    nationalId: "Rijksregisternummer",
    maritalStatus: "Burgerlijke staat",
    bloodType: "Bloedgroep",
    idExpiryDate: "Vervaldatum Identiteitskaart",
    licenseExpiryDate: "Vervaldatum Rijbewijs",
    ocrHint: "Automatisch ingevuld bij uploaden",
    ocrProcessing: "Document scannen, datums extraheren...",
    ocrExpiryFound: "Vervaldatum gevonden",
    ocrDatesFound: "Datums gevonden",
    ocrNoDateFound: "Geen datum gevonden in document. Voer handmatig in.",
    ocrError: "OCR scan fout",
    employmentDates: "Dienstverband Data",
    employmentStartDate: "Datum in Dienst",
    employmentEndDate: "Datum uit Dienst",
    employmentDatesUpdated: "Dienstverband data bijgewerkt",
    employmentDatesError: "Kon data niet bijwerken",
    single: "Ongehuwd",
    married: "Gehuwd",
    divorced: "Gescheiden",
    widowed: "Weduwe/Weduwnaar",
    cohabiting: "Wettelijk samenwonend",
    addressInfo: "Adresgegevens",
    street: "Straat",
    houseNumber: "Huisnummer",
    postalCode: "Postcode",
    city: "Woonplaats",
    country: "Land",
    contactBankInfo: "Contact & Bankgegevens",
    phone: "GSM",
    emailAddress: "E-mailadres",
    bankAccount: "Bankrekening (IBAN)",
    fiscalInfo: "Fiscale Gezinssituatie",
    fiscalInfoDesc: "Geef aan welke personen fiscaal ten laste zijn",
    childrenDependent: "Kinderen fiscaal ten laste",
    numberOfChildren: "Aantal kinderen",
    spouseDependent: "Echtgeno(o)t(e) fiscaal ten laste",
    otherDependents: "Andere personen fiscaal ten laste",
    numberOfOtherDependents: "Aantal personen",
    importantDocuments: "Belangrijke Documenten",
    importantDocumentsDesc: "Uw identiteitskaart, bestuurdersattest en rijbewijs documenten",
    frontSide: "Voorkant",
    backSide: "Achterkant",
    showFrontSide: "Toon voorkant",
    showBackSide: "Toon achterkant",
    noDocuments: "Nog geen documenten beschikbaar",
    noDocumentsDesc: "Uw beheerder kan documenten aan u toewijzen",
    firstUpload: "Eerste document uploaden",
    documentType: "Document Type",
    documentNumber: "Documentnummer",
    issueDate: "Afgiftedatum",
    expiryDate: "Verloopdatum",
    notes: "Notities",
    download: "Download",
    selectFile: "Selecteer bestand",
    dragDrop: "Klik om te uploaden of sleep bestand",
    fileTypes: "PDF, JPG, PNG, DOC (max 10MB)",
    uploadedBy: "Geüpload door",
    date: "Datum",
    idCard: "Identiteitskaart",
    passport: "Paspoort",
    driverLicense: "Rijbewijs",
    residencePermit: "Verblijfsvergunning",
    workContract: "Arbeidsovereenkomst",
    diploma: "Diploma/Certificaat",
    medicalCert: "Medisch attest",
    bankDetails: "Bankgegevens",
    taxForm: "Belastingfiche",
    other: "Overige",
    approved: "Goedgekeurd",
    pending: "In behandeling",
    leaveDays: "Verlofdagen",
    workDays: "Werkdagen",
    recentLeaves: "Recente Verlofaanvragen",
    approvedDates: "Goedgekeurde Datums",
    noLeaves: "Geen verlofaanvragen",
    totalDebt: "Totale Schuld",
    totalPaid: "Totaal Betaald",
    bonus: "Bonus",
    netBalance: "Netto Saldo",
    transactionHistory: "Transactiegeschiedenis",
    noTransactions: "Geen transacties",
    financeHidden: "Financiële informatie is verborgen door de beheerder",
    advance: "Voorschot",
    debt: "Schuld",
    payment: "Betaling",
    deduction: "Inhouding",
    bonusType: "Bonus",
    potPlus: "POT+ (Tegoed)",
    potMinus: "POT- (Schuld)",
    laadvergoeding: "Laadvergoeding (Elektriciteit)",
    leasing: "Leasing",
    otherType: "Andere",
    addNew: "Nieuw",
    amount: "Bedrag",
    description: "Omschrijving",
    deleteRecord: "Record Verwijderen",
    deleteConfirm: "Weet je zeker dat je deze record wilt verwijderen?",
    employeesFound: "werknemers gevonden",
    searchPlaceholder: "Zoeken op naam of e-mail...",
    allProfiles: "Alle profielen",
    completeProfiles: "Volledig",
    incompleteProfiles: "Onvolledig",
    allFirms: "Alle firma's",
    avgCompletion: "Gem. voltooiing",
    noEmployees: "Geen werknemers gevonden",
    exportCsv: "Export CSV",
    employee: "Werknemer",
    contact: "Contactgegevens",
    profile: "Profiel",
    profileSaved: "Profiel opgeslagen",
    profileSaveError: "Profiel opslaan mislukt",
    documentUploaded: "Document geüpload",
    documentsUploaded: "documenten geüpload",
    documentUploadError: "Upload mislukt",
    dragDropMultiple: "Sleep bestanden hierheen",
    orClickToSelect: "of klik om te selecteren",
    clickToAddMore: "Klik of sleep om meer bestanden toe te voegen",
    filesSelected: "bestanden geselecteerd",
    invalidFileType: "Sommige bestanden hebben een niet-ondersteund formaat",
    forUpload: "document uploaden voor",
    dropFilesHere: "Bestanden hier neerzetten",
    filesWillBeUploaded: "Bestanden worden geüpload",
    dragDropHint: "Tip: U kunt bestanden snel uploaden door ze naar dit gebied te slepen",
    deleteDocumentTitle: "Document Verwijderen",
    deleteDocumentConfirm: "Weet u zeker dat u dit document wilt verwijderen?",
    deleteDocumentWarning: "Deze actie kan niet ongedaan worden gemaakt.",
    documentDeleted: "Document verwijderd",
    documentDeleteError: "Verwijderen mislukt",
    editDocument: "Document Bewerken",
    documentUpdated: "Document bijgewerkt",
    documentUpdateError: "Document bijwerken mislukt",
    categoryHint: "Selecteer de documentcategorie",
    currentCategory: "Huidige Categorie",
    documentSideUploaded: "geüpload",
    unsupportedFileFormat: "Niet-ondersteund bestandsformaat. Upload JPG, PNG, PDF of HEIC.",
    downloadError: "Download mislukt",
    loadError: "Laden mislukt",
    payslipsDesc: "Uw maandelijkse loonbrieven",
    noPayslips: "Nog geen loonbrieven geüpload",
    noPayslipsDesc: "Uw loonbrieven worden hier getoond zodra ze geüpload zijn",
    packagesDesc: "Uw pakketbezorgingsgegevens",
    noPackages: "Geen pakketgegevens gevonden",
    noPackagesDesc: "Pakketbezorgingsgegevens worden hier getoond zodra beschikbaar",
    category: "Categorie",
    personal: "Persoonlijk",
    company: "Bedrijf",
    back: "Terug",
    uploadBtn: "Uploaden",
    cancelBtn: "Annuleren",
    deleteBtn: "Verwijderen",
    completeProfileTitle: "Vul uw profiel in",
    completeProfileDesc: "Vul a.u.b. uw profielgegevens in voordat u verder gaat.",
    goToProfile: "Naar Profiel",
    selectFileAndType: "Selecteer een bestand en document type",
    expiringDocuments: "Bijna Verlopende Documenten",
    expiringDocumentsDesc: "Medewerkers met documenten die bijna verlopen",
    expired: "Verlopen",
    noExpiringDocuments: "Geen bijna verlopende documenten",
    daysRemaining: "dagen resterend",
    requiredFields: "Vul verplichte velden in",
    addNote: "Notitie Toevoegen",
    addNoteDesc: "Voeg een privé notitie toe over deze medewerker (alleen beheerders zien dit)",
    notePlaceholder: "Schrijf hier uw notitie...",
    notesList: "Notities",
    noNotes: "Nog geen notities",
    packagesTab: "Pakketten",
    today: "Vandaag",
    yesterday: "Gisteren",
    thisWeek: "Deze Week",
    thisMonth: "Deze Maand",
    thisYear: "Dit Jaar",
    allRegions: "Alle Regio's",
    totalPackages: "Totaal Pakketten",
    workedDays: "Gewerkte Dagen",
    dailyAvg: "Dagelijks Gem.",
    region: "Regio",
    totalAmount: "Totaal Bedrag",
    dailyPackageDist: "Dagelijkse Pakketverdeling",
    last30DaysPackages: "Aantal pakketten van de laatste 30 dagen",
    regionDist: "Regio Verdeling",
    regionDistDesc: "Pakketverdeling per regio",
    packageCount: "stuks",
    packageLabel: "Pakket",
    amountLabel: "Bedrag",
    loonbriefsTab: "Loonbrieven",
    loonbriefsTitle: "Loonbrieven",
    loonbriefsDesc: "geüploade loondocumenten voor",
    uploadedOn: "geüpload op",
    viewBtn: "Bekijken",
    downloadBtn: "Downloaden",
    noLoonbriefs: "Nog geen loonbrieven geüpload",
    noLoonbriefsDesc: "U kunt loonbrieven uploaden via de Loonbrief Upload pagina",
    allYears: "Alle Jaren",
    selectMonth: "Selecteer Maand",
    period: "Periode",
    viewProfile: "Profiel Bekijken",
    applyOcrData: "Gegevens Toepassen",
    ocrAllDatesHint: "Andere gevonden datums (klik om te selecteren):",
    ocrResultsEditableDesc: "Datums gevonden door OCR-scan worden hieronder weergegeven. U kunt ze corrigeren of handmatig invoeren indien onjuist.",
    documentEditor: {
      dragDropTitle: "Sleep het document hierheen",
      supportedFormats: "JPG, PNG, WEBP, PDF ondersteund",
      selectFile: "Selecteer Bestand",
      pasteFromClipboard: "Plakken van Klembord",
      pasteHint: "Druk Ctrl+V om direct van het klembord te plakken",
      rotateLeft: "Links Draaien",
      rotateRight: "Rechts Draaien",
      flipHorizontal: "Horizontaal Spiegelen",
      flipVertical: "Verticaal Spiegelen",
      reset: "Reset",
      changeImage: "Ander Bestand Selecteren",
      save: "Opslaan",
      saveAndUpload: "Opslaan & Uploaden",
      cancel: "Annuleren",
      crop: "Bijsnijden",
      applyChanges: "Wijzigingen Toepassen",
      deleteDocument: "Document Verwijderen",
      deleteConfirm: "Weet u zeker dat u dit document wilt verwijderen?",
      deleteSuccess: "Document verwijderd",
      processing: "Verwerken...",
      zoom: "Zoom",
      edit: "Bewerken",
      editing: "Bewerken",
      readyToUpload: "Klaar om te Uploaden",
      rotate: "Draaien",
      zoomIn: "Inzoomen",
      zoomOut: "Uitzoomen",
      cropAndUpload: "Bijsnijden en uploaden",
      skipEdit: "Bewerken overslaan",
    },
    addAliasPlaceholder: "Nieuwe alias toevoegen...",
    aliases: "Aliassen / Secundaire Namen",
    aliasesDescription: "Gebruikt voor loonstrook PDF-matching. Bijv: GEMALMAZ H.",
    aliasesSaved: "Aliassen opgeslagen",
    aliasesTab: "Aliassen",
    financeTab: "Financiën",
    financeTitle: "Financiële Gegevens",
    manualEntry: "Handmatige Invoer",
    noAliases: "Nog geen aliassen gedefinieerd",
    noFinanceRecords: "Geen financiële gegevens",
    ocrDetectedDates: "OCR Gedetecteerde Datums",
    ocrNoResults: "Geen datums gedetecteerd",
    removeAlias: "Alias verwijderen",
    saveAliases: "Aliassen Opslaan",
    showAdvancedSection: "Geavanceerd Tonen",
    totalAdvance: "Totaal Voorschot",
    totalRecords: "Totaal Records",
    applyDates: "Datums Toepassen",
    changePhoto: "Foto Wijzigen",
    clickForDetails: "Klik voor details",
    cropAndEdit: "Bijsnijden en Bewerken",
    details: "Details",
    driverLicenseDesc: "Rijbewijsdocument",
    identityCard: "Identiteitskaart",
    identityCardDesc: "Identiteitskaartdocument",
    noPotEntries: "Geen tijdregistratie-items",
    notUploaded: "Niet geüpload",
    ocrResults: "OCR Resultaten",
    ocrResultsDesc: "Datums gevonden uit document",
    openInNewTab: "Openen in nieuw tabblad",
    otherDocuments: "Overige Documenten",
    passportDesc: "Paspoortdocument",
    photoUploadError: "Foto uploaden mislukt",
    photoUploaded: "Foto geüpload",
    uploadCover: "Omslagfoto Uploaden",
    coverUploaded: "Omslagfoto geüpload",
    coverUploadError: "Omslagfoto uploaden mislukt",
    addJobTitle: "+ Rol / functie toevoegen",
    jobTitlePlaceholder: "Rol / functie (bv. Super Admin)",
    addBio: "+ Korte bio toevoegen",
    bioPlaceholder: "Korte bio (max 280 tekens)",
    preview: "Voorbeeld",
    profilePhoto: "Profielfoto",
    upload: "Uploaden",
    uploadPhoto: "Foto Uploaden",
    uploaded: "Geüpload",
  },
  documents: {
    myDocuments: "Mijn Documenten",
    myDocumentsDesc: "Bedrijfscontracten en persoonlijke documenten",
    management: "Documentbeheer",
    managementDesc: "Beheer bedrijfsdocumenten en personeelsdossiers",
    searchPlaceholder: "Zoeken in bestanden...",
    all: "Alles",
    companyDocs: "Bedrijfsdocumenten",
    personalDocs: "Persoonlijke Documenten",
    noDocuments: "Nog geen bestanden",
    noDocumentsDesc: "Geen bestanden aan u toegewezen",
    noDocumentsAdminDesc: "Upload bestanden voor uw medewerkers",
    company: "Bedrijf",
    personal: "Persoonlijk",
    preview: "Bekijken",
    download: "Downloaden",
    fetchError: "Bestanden laden mislukt",
    downloadSuccess: "Bestand wordt gedownload",
    downloadError: "Bestand downloaden mislukt",
    previewError: "Preview openen mislukt",
    uploadError: "Bestand uploaden mislukt",
    updateSuccess: "Bestand bijgewerkt",
    updateError: "Bestand bijwerken mislukt",
    deleteSuccess: "Bestand verwijderd",
    deleteError: "Bestand verwijderen mislukt",
    deleteConfirm: "Bestand Verwijderen",
    upload: "Bestand Uploaden",
    uploadFiles: "Bestanden Uploaden",
    uploadDesc: "Organiseer bestanden en wijs toe aan medewerkers",
    uploadFirst: "Upload Eerste Bestand",
    files: "Bestanden",
    fileName: "Bestandsnaam",
    firm: "Bedrijf",
    category: "Categorie",
    assignedTo: "Toegewezen Aan",
    assignTo: "Toewijzen Aan",
    assignToAll: "Toewijzen aan alle medewerkers",
    searchUsers: "Zoek medewerker...",
    size: "Grootte",
    uploadedAt: "Geüpload",
    editDocument: "Bestand Bewerken",
    invalidFileType: "Sommige bestanden hebben een niet-ondersteund formaat",
    targetFirm: "Doelbedrijf",
    allCompanies: "Alle Bedrijven (Globaal)",
    globalDocNote: "Globaal document is zichtbaar voor alle bedrijfsmedewerkers",
    pdfLoadError: "PDF laden mislukt",
    pdfCorruptOrInvalid: "Het bestand is mogelijk beschadigd of een ongeldige PDF",
    downloadInstead: "Bestand Downloaden",
    previewNotSupported: "Preview niet beschikbaar voor dit bestandstype",
    noPreview: "Preview niet beschikbaar",
    showing: "Weergeven",
    of: "van",
    items: "items",
    perPage: "Per pagina",
    originalName: "Origineel",
    filterByFirm: "Filteren op Bedrijf",
    uploadSuccess: "Bestand geüpload",
    allDocuments: "Alle documenten",
    assignedDocuments: "Toegewezen documenten",
    assignedToMe: "Aan mij toegewezen",
    companyDocuments: "Bedrijfsdocumenten",
    dateRange: "Datumbereik",
    deleteMessage: "Dit document wordt permanent verwijderd.",
    documentName: "Documentnaam",
    documentType: "Documenttype",
    dragDrop: "Sleep bestanden hierheen of klik om te selecteren",
    employee: "Medewerker",
    fileSize: "Bestandsgrootte",
    fileUploaded: "Bestand geüpload",
    filterByType: "Filter op type",
    firmDocuments: "Bedrijfsdocumenten",
    firmDocumentsDesc: "Documenten gedeeld met het hele bedrijf",
    noResults: "Geen documenten gevonden",
    or: "of",
    private: "Privé",
    public: "Openbaar",
    selectEmployee: "Medewerker selecteren",
    selectFile: "Bestand selecteren",
    totalDocuments: "Totaal documenten",
    uploadDate: "Uploaddatum",
    uploadDocument: "Document uploaden",
    uploadDocumentDesc: "Upload een nieuw document",
    uploadedBy: "Geüpload door",
    visibility: "Zichtbaarheid",
    visibleToEmployee: "Zichtbaar voor medewerker",
  },
  employeeTracking: {
    title: "Medewerker Tracking",
    description: "Volg de dagelijkse status van medewerkers",
    filter: "Filter",
    searchEmployee: "Zoek medewerker...",
    noResults: "Geen resultaten gevonden",
    globalSearch: "Zoek medewerker of kenteken...",
    clearFilter: "Filter Wissen",
    employee: "Medewerker",
    employees: "Medewerkers",
    all: "Alles",
    selectFirm: "Selecteer bedrijf",
    daySummary: "Dag Overzicht",
    totalWorking: "Totaal Gewerkt",
    totalLeave: "Totaal Verlof",
    totalSick: "Totaal Ziek",
    totalDop: "Totaal DOP",
    noEmployeeFound: "Geen actieve medewerkers gevonden",
    noFilterMatch: "Geen medewerkers voldoen aan de filtercriteria",
    firmsLoadError: "Bedrijven laden mislukt",
    dataLoadError: "Gegevens laden mislukt",
    status: {
      working: "Gewerkt",
      halfDay: "Halve Dag",
      sick: "Ziek",
      dop: "DOP",
      onLeave: "Verlof",
      holiday: "Feestdag",
      halfSick: "Half Ziek",
      saturday: "Zaterdag",
      paternity: "Vaderschapsverlof",
      unknown: "Onbekend",
    },
    months: {
      january: "Januari",
      february: "Februari",
      march: "Maart",
      april: "April",
      may: "Mei",
      june: "Juni",
      july: "Juli",
      august: "Augustus",
      september: "September",
      october: "Oktober",
      november: "November",
      december: "December",
    },
    days: {
      sun: "Zo",
      mon: "Ma",
      tue: "Di",
      wed: "Wo",
      thu: "Do",
      fri: "Vr",
      sat: "Za",
    },
  },
  routes: {
    title: "Routes / Tours",
    description: "Beheer dagelijkse route- en tourgegevens",
    allRoutes: "Routelijst",
    newRoute: "Nieuwe Route",
    editRoute: "Route Bewerken",
    addRoute: "Nieuwe Route Toevoegen",
    importExcel: "Excel Importeren",
    exportExcel: "Excel Exporteren",
    recalculate: "Herberekenen",
    recalculateTitle: "Alle Ritten Herberekenen",
    recalculateBody: "Alle bestaande rittenrecords' werkuren en totaalbedragen worden opnieuw berekend met de huidige berekeningsregels. Oude foutieve records (bv. uurloon=0) worden gecorrigeerd. Deze actie kan niet ongedaan worden gemaakt.",
    customer: "Klant",
    customers: "Klanten",
    multiSelect: "Meerdere selecteren",
    firm: "Bedrijf",
    allFirms: "Alle Bedrijven",
    month: "Maand",
    allMonths: "Alle Maanden",
    search: "Zoeken",
    searchPlaceholder: "Chauffeur, kenteken...",
    date: "Datum",
    licensePlate: "Kenteken",
    driver: "Chauffeur",
    copilot: "Bijrijder",
    routeNumber: "Route Nr",
    routeType: "Route Type",
    ritNumber: "Rit Nr",
    rit: "Rit",
    tour: "Tour",
    routeRitTour: "Route/Rit/Tour",
    place: "Plaats",
    startTime: "Start",
    endTime: "Einde",
    breakTime: "Pauze",
    workHours: "Werkuren",
    hourlyRate: "Uurtarief",
    startCost: "Startkosten",
    workCost: "Werkkosten",
    totalCost: "Totaal",
    kmStart: "Start KM",
    kmEnd: "Eind KM",
    kmTotal: "Totaal KM",
    km: "KM",
    time: "Tijd",
    price: "Prijs",
    total: "Totaal",
    actions: "Acties",
    edit: "Bewerken",
    delete: "Verwijderen",
    save: "Opslaan",
    cancel: "Annuleren",
    close: "Sluiten",
    selectAll: "Alles Selecteren",
    deleteSelected: "Geselecteerde Verwijderen",
    confirmDelete: "Weet u zeker dat u dit record wilt verwijderen?",
    confirmBulkDelete: "Weet u zeker dat u {count} geselecteerde records wilt verwijderen?",
    noRecords: "Geen records gevonden voor deze maand",
    addFirstRecord: "Eerste Record Toevoegen",
    records: "records",
    deleteRecords: "Records Verwijderen",
    selectRow: "Rij selecteren",
    selectAllOnPage: "Alles op deze pagina selecteren",
    perPage: "Per pagina",
    firstPage: "Eerste pagina",
    previousPage: "Vorige pagina",
    nextPage: "Volgende pagina",
    lastPage: "Laatste pagina",
    editAllFields: "Alle velden bewerken",
    copyWithToday: "Kopiëren (met datum van vandaag)",
    copyRecords: "record kopiëren",
    exportFiltered: "Gefilterde gegevens exporteren",
    viewAttachments: "Bestandsbijlagen",
    summary: {
      totalRecords: "Totaal Records",
      totalHours: "Totaal Uren",
      totalKm: "Totaal KM",
      totalAmount: "Totaal Bedrag",
      perRecord: "gem. per record",
    },
    import: {
      title: "Importeren uit Excel",
      multiSheetSupport: "Multi-Blad Ondersteuning",
      customerType: "Klanttype",
      pleaseSelectCustomer: "Selecteer een klanttype",
      columnMapping: "Excel-kolommen worden gematcht volgens geselecteerd klanttype",
      firmLabel: "Bedrijf:",
      selectFirm: "Selecteer bedrijf",
      required: "Verplicht",
      dragDropFile: "Sleep bestand of klik",
      dropFileHere: "Laat bestand hier vallen...",
      fileFormats: "CSV of Excel (.xlsx) • Meerdere bladen ondersteund",
      selectFile: "Selecteer Bestand",
      unsupportedFormat: "Niet-ondersteund bestandsformaat. Selecteer .xlsx, .xls of .csv bestand.",
      excelLoaded: "Excel geladen",
      sheetsCount: "bladen",
      totalRows: "totaal rijen",
      rowsRead: "rijen gelezen",
      fileReadError: "Bestand lezen mislukt",
      sheetSelection: "Blad Selectie",
      sheetsSelected: "bladen geselecteerd",
      rows: "rijen",
      selectDeselectAll: "Alles Selecteren / Deselecteren",
      noData: "Geen gegevens",
      preview: "Voorbeeld",
      toImport: "Te Importeren",
      sheet: "blad",
      selectedSheets: "Geselecteerde bladen",
      moverColumns: "Mover Excel Kolommen:",
      fedexColumns: "FedEx Excel Kolommen:",
      expressColumns: "Express Excel Kolommen:",
      getaxColumns: "GeTax Excel Kolommen:",
      optionalFields: "Optioneel",
      defaultRate: "standaard",
      startCost: "Start kost",
      notes: "Opmerkingen",
      selectCustomerType: "Selecteer Klanttype",
      importRecords: "Records Importeren",
      importSheets: "Blad",
      noDataToImport: "Geen gegevens om te importeren",
      andMore: "en",
      moreRows: "meer rijen (op dit blad)",
      duplicateWarning: "dubbele records overgeslagen",
      selectSheet: "Selecteer Blad",
      selectCustomer: "Selecteer Klanttype",
      customerRequired: "Selecteer eerst klanttype",
      dragDrop: "Slepen of klikken",
      rowsFound: "rijen gevonden",
      import: "Importeren",
      importing: "Importeren...",
      success: "records succesvol geïmporteerd",
      duplicatesSkipped: "dubbele records overgeslagen",
      error: "Importfout",
      moreRecords: "meer records",
    },
    form: {
      selectDate: "Selecteer datum",
      selectDriver: "Selecteer chauffeur",
      selectCopilot: "Selecteer bijrijder",
      selectVehicle: "Selecteer voertuig",
      manualEntry: "Handmatige invoer",
      searchEmployee: "Zoek werknemer...",
      noEmployeeFound: "Geen werknemer gevonden",
      calculation: "Berekening",
      searchDriver: "Zoek chauffeur...",
      searchCopilot: "Zoek bijrijder...",
      driverNotFound: "Chauffeur niet gevonden",
      loading: "Laden...",
      customerRequired: "Klant *",
      customerCannotChange: "Klant kan niet worden gewijzigd tijdens bewerken",
      firmRequired: "Bedrijf *",
      selectFirm: "Selecteer bedrijf",
      dateRequired: "Datum *",
      routeNumberLabel: "Route Nummer",
      routeNumberPlaceholder: "Bijv.: 741",
      tourTypeRequired: "Tour Type *",
      selectTour: "Selecteer tour",
      tourTypePlaceholder: "Voer tour type in...",
      ritRequired: "Rit *",
      selectRit: "Selecteer rit",
      enterRit: "Voer rit in...",
      list: "Lijst",
      vehiclePlateRequired: "Kenteken *",
      searchPlate: "Zoek en selecteer kenteken...",
      selectFirmFirst: "Selecteer eerst bedrijf",
      searchPlatePlaceholder: "Zoek kenteken...",
      vehicleNotFound: "Voertuig niet gevonden",
      orManualEntry: "of handmatig invoeren:",
      enterPlate: "Voer kenteken in...",
      driverRequired: "Chauffeur *",
      searchAndSelectDriver: "Zoek en selecteer chauffeur...",
      enterDriverName: "Chauffeur naam",
      allDrivers: "Alle Chauffeurs",
      firmDrivers: "Bedrijf Chauffeurs",
      copilotLabel: "Bijrijder (Copilot)",
      searchAndSelectCopilot: "Zoek en selecteer bijrijder...",
      enterCopilotName: "Bijrijder naam",
      kmStartLabel: "KM Start",
      kmStartPlaceholder: "Bijv.: 40447",
      kmEndLabel: "KM Einde",
      kmEndPlaceholder: "Bijv.: 40531",
      hourlyRateLabel: "Uurtarief (€)",
      startCostLabel: "Startkosten (€)",
      startTimeLabel: "Starttijd",
      endTimeLabel: "Eindtijd",
      breakTimeLabel: "Pauzetijd",
      calculatedValues: "Berekende Waarden",
      totalKm: "Totaal KM:",
      workDuration: "Werktijd:",
      totalAmount: "Totaal Bedrag:",
      notesLabel: "Opmerkingen",
      notesPlaceholder: "Extra opmerkingen...",
    },
    messages: {
      saveSuccess: "Route opgeslagen",
      saveError: "Route opslaan mislukt",
      deleteSuccess: "Route verwijderd",
      deleteError: "Route verwijderen mislukt",
      bulkDeleteSuccess: "records verwijderd",
      bulkDeleteError: "Records verwijderen mislukt",
      loadError: "Gegevens laden mislukt",
      exportSuccess: "records geëxporteerd",
      exportError: "Exportfout",
      recalculated: "records herberekend",
      alreadyCorrect: "al correct",
      recalculateError: "Herberekeningsfout",
      routeUpdated: "Route bijgewerkt",
      routeAdded: "Route toegevoegd",
      routeDeleted: "Route verwijderd",
      routeCopied: "Route gekopieerd",
      copyFailed: "Kopiëren mislukt",
      errorOccurred: "Er is een fout opgetreden",
      updated: "Bijgewerkt",
      updateError: "Bijwerken mislukt",
      driverUpdated: "Chauffeur bijgewerkt",
      selectRecordsToDelete: "Selecteer records om te verwijderen",
      bulkDeleteConfirm: "{count} records worden verwijderd. Weet u het zeker?",
      bulkDeleteError2: "Bulk verwijderen mislukt",
    },
    table: {
      clickToEdit: "Dubbelklik op cel om te bewerken",
      hoverIcon: "potloodpictogram verschijnt bij hover",
      doubleClickStart: "Dubbelklik: Starttijd",
      doubleClickEnd: "Dubbelklik: Eindtijd",
    },
  },
  routeReports: {
    title: "Route Rapporten",
    description: "Bekijk route- en tourstatistieken",
    customer: "Klant",
    firm: "Bedrijf",
    allFirms: "Alle Bedrijven",
    dateRange: "Datumbereik",
    startDate: "Startdatum",
    endDate: "Einddatum",
    filter: "Filteren",
    summary: "Samenvattende Statistieken",
    totalRoutes: "Totaal Routes",
    totalHours: "Totaal Uren",
    totalKm: "Totaal KM",
    totalAmount: "Totaal Bedrag",
    avgPerDay: "Dagelijks Gemiddelde",
    avgPerRoute: "Per Route Gemiddelde",
    monthlyTrend: "Maandelijkse Trend",
    weeklyTrend: "Wekelijkse Trend",
    driverStats: "Chauffeur Statistieken",
    vehicleStats: "Voertuig Statistieken",
    noData: "Geen gegevens gevonden voor geselecteerde criteria",
    loadError: "Rapporten laden mislukt",
    records: "Records",
    currentPeriod: "Huidige Periode",
    previousPeriod: "Vorige Periode",
    last6MonthsLabel: "Laatste 6 Maanden",
    previous6MonthsLabel: "Vorige 6 Maanden",
    last12MonthsLabel: "Laatste 12 Maanden",
    previous12MonthsLabel: "Vorige 12 Maanden",
    driverDetails: "Chauffeur Details",
    routeCount: "Aantal Routes",
    totalIncome: "Totale Inkomsten",
    periodComparison: "Periodevergelijking",
    last6Months: "Laatste 6 Maanden vs Vorige",
    last12Months: "Laatste 12 Maanden vs Vorige",
    growthSummary: "Groei Overzicht",
    driverVehicleMatrix: "Chauffeur-Voertuig Prestatiematrix",
    driverVehicleMatrixDesc: "Bekijk hoe elke chauffeur presteert met verschillende voertuigen",
    driver: "Chauffeur",
    vehicleTotal: "Voertuig Totaal",
    showingTopDrivers: "Top",
    drivers: "chauffeurs weergegeven",
  },
  lockScreen: {
    sessionLocked: "Sessie Vergrendeld",
    sessionLockedDesc: "Sessie is vergrendeld",
    unlockSession: "Sessie ontgrendeld",
    passwordPlaceholder: "Voer uw wachtwoord in...",
    authPlaceholder: "Authenticatie...",
    wrongPassword: "Onjuist wachtwoord",
    unlock: "Ontgrendelen",
    or: "of",
    logout: "Uitloggen",
    lockScreen: "Scherm Vergrendelen",
    inactivityMessage: "Vergrendeld wegens {{minutes}} minuten inactiviteit",
    inactivityShort: "{{minutes}} min inactiviteit",
    biometricUnlock: "Ontgrendelen met Biometrie",
    biometricFailed: "Biometrische verificatie mislukt",
    biometricSuggestion: "U kunt biometrische ontgrendeling (vingerafdruk of gezichtsherkenning) registreren via uw profielbeveiligingsinstellingen.",
    biometricSecurity: "Biometrische Beveiliging",
    biometricDescription: "Ontgrendel het vergrendelscherm snel met vingerafdruk of gezichtsherkenning.",
    biometricRegistered: "Biometrische registratie geslaagd!",
    biometricCancelled: "Biometrische registratie geannuleerd",
    biometricDeleted: "Biometrische registratie verwijderd",
    registerBiometric: "Biometrie Registreren",
    addAnotherDevice: "Ander Apparaat Toevoegen",
    registeredDevices: "geregistreerd(e) apparaat/apparaten",
    lastUsed: "Laatst gebruikt",
    registered: "Geregistreerd",
    dismiss: "Sluiten",
    idleTimeout: "Sessievergrening Timeout",
    idleTimeoutDesc: "Scherm wordt automatisch vergrendeld na inactiviteit",
  },
  settings: {
    securitySettings: "Beveiligingsinstellingen",
    lockScreenSettings: "Sessievergrendeling en beveiligingsinstellingen",
    minutes: "minuten",
    idleTimeoutDescription: "Het scherm wordt automatisch vergrendeld wanneer de gebruiker gedurende de opgegeven duur inactief is. (1-120 minuten)",
  },
  email: {
    mandrill_api_key: "Mandrill API-sleutel",
    smtp_pass: "SMTP-wachtwoord",
  },
  sms: {
    api_key: "SMS API-sleutel",
  },
  whatsapp: {
    api_key: "WhatsApp API-sleutel",
  },
  planning: {
    days: {
      0: "Maandag", 1: "Dinsdag", 2: "Woensdag", 3: "Donderdag",
      4: "Vrijdag", 5: "Zaterdag", 6: "Zondag"
    },
    copyDayToNext: "Kopieer {{day}} → {{next}}",
    spreadDayTitle: "Verspreid {{day}} over de overige {{remaining}} weekdagen (excl. zondag)",
    prevWeek: "Vorige week",
    nextWeek: "Volgende week",
    copyFromPrevWeek: "Kopieer van vorige week",
    depotAndRoutes: "Depot & Routes",
    deleteWeekTitle: "Verwijder alle toewijzingen van deze week",
    firmDepotRoute: "Bedrijf / Depot / Route",
    viewConflicts: "Conflicten bekijken",
    boardCanvas: {
      title: "Planbord",
      zoomIn: "Inzoomen",
      zoomOut: "Uitzoomen",
      fitAll: "Alles passend",
      preparing: "Bezig met laden…",
      assignmentsCount: "{{count}} toewijzingen",
      downloadExcelTitle: "Gekleurde Excel downloaden",
      open: "Open",
      noAssignmentsWeek: "Geen toewijzingen deze week",
      moreFirms: "+{{count}} meer firma's — gebruik \"Open\" voor details",
      dayCol: "Dag",
      depot: "DEPOT",
      excelDownloaded: "W{{week}} gekleurde Excel gedownload",
      downloadFailed: "Download mislukt",
      dataLoadFailed: "Laden van gegevens mislukt",
      legend: { depot: "DEPOT", assignment: "Toewijzing", driver: "Chauffeur", day: "Dag" },
      legendToggle: "Legenda"
    }
  },
  dpd: {
    common: {
      firm: "Firma", date: "Datum", dateFrom: "Van", dateTo: "Tot",
      refresh: "Vernieuwen", loading: "Laden...", noData: "Geen data",
      total: "Totaal", search: "Zoeken...", clear: "Wissen", cancel: "Annuleren",
      delete: "Verwijderen", preview: "Voorbeeld", page: "Pagina", pageSize: "Paginagrootte",
      first: "Eerste", last: "Laatste", prev: "Vorige", next: "Volgende",
      preset7: "Laatste 7 dagen", preset14: "Laatste 14 dagen", preset30: "Laatste 30 dagen",
      preset90: "Laatste 90 dagen", preset3: "Laatste 3 dagen",
      day: "dag", tour: "Rit", courier: "Chauffeur", subco: "Subco",
      packages: "Pakketten", stops: "Stops", km: "Km", hours: "Uren",
      retour: "Retour", deliveryRate: "Bezorgpercentage", successRate: "Slaagpercentage %",
      fastTrans: "Fast-Trans", ownCompany: "Uw Bedrijf", activeDays: "Actieve Dagen"
    },
    dailySummary: {
      title: "DPD Dagoverzicht", subtitle: "Fast-Trans DPD ritten — chauffeur, stops, pakketten en afstand",
      ingestFromMail: "Importeren uit Mailarchief",
      cols: { tour: "Rit", courier: "Chauffeur", chassis: "Nummerplaat/Chassis", stops: "Stops", parcels: "Pakketten", retourPlan: "Retour Plan", km: "Km", duration: "Duur", start: "Start", end: "Einde", endpoint: "Endpoint" },
      stats: { tours: "Ritten", totalStops: "Totaal Stops", delivered: "Bezorgd", totalKm: "Totaal Km", retour: "Retour" }
    },
    driverPerformance: {
      title: "DPD Chauffeur & Rit Prestaties",
      subtitle: "Totale pakketten, bezorgpercentage, retours en afstand per {{group}} in de gekozen periode.",
      groupCourier: "Per Chauffeur", groupTour: "Per Rit",
      trendTitle: "Wekelijkse Trend (Laatste 8 Weken)",
      cols: { courier: "Chauffeur", tour: "Rit", days: "Dagen", tours: "Ritten", couriers: "Chauffeurs", parcels: "Pakketten", stops: "Stops", retour: "Retour", deliveryPct: "Bezorg %", km: "Km", hours: "Uren", avgKmDay: "Gem. Km/Dag" },
      colorLegend: "Kleurenschaal:",
      empty: "Geen data voor de geselecteerde periode."
    },
    consolidated: {
      title: "DPD Geconsolideerd Dagelijks Operationeel Rapport",
      subtitle: "Fast-Trans dagelijkse geconsolideerde prestaties: slaagpercentage, oorzaakanalyse van retours en automatische managementinzichten.",
      modeSingle: "Één Dag", modeRange: "Datumbereik",
      kpi: {
        parcelsPlan: "Uitgezette Pakketten", tourSum: "Totaal van {{count}} lijnen", tourSumRange: "{{tours}} lijnen × {{days}} dagen",
        deliveredSA13: "Succesvolle Bezorging (SA13)", deliveryRatio: "Bezorging: {{rate}}%",
        returnedSA23: "Mislukte Bezorging (SA23)", returnRate: "Retour: {{rate}}%",
        pickupSA15: "Opgehaald (SA15)", pickupSubtitle: "Chauffeurs' Pickups",
        ftRetour: "Fast Trans Retour", scannedOthers: "Gescand in depot ({{others}} andere)",
        totalKm: "Totaal Km", kmPerParcel: "Gem. {{v}} km/pakket",
        totalHours: "Totaal Werkuren", hoursPerTour: "Gem. {{v}} u/lijn",
        activeLines: "Actieve Lijnen", activeLinesSubtitle: "Fast-Trans"
      },
      tourTableTitle: "Fast Trans — Lijn & Chauffeur Eindprestaties",
      tourCols: { date: "Datum", line: "Lijn", driverChassis: "Chauffeur & Chassis", plan: "Plan", sa13: "SA13", sa23: "SA23", sa15: "SA15", distance: "Afstand", durationOFD: "Tijd (OFD)", parcelsPerHour: "Pakketten/u", endpoint: "Endpoint", successPct: "Slaag %" },
      reasonBreakdown: "Retour Redencode Verdeling (Fast Trans)",
      reasonCols: { code: "Code", label: "Beschrijving", count: "Aantal", pct: "%", chart: "Verdeling" },
      retourDetayTitle: "Retour Details: Ontvanger, Adres en Reden",
      retourDetayHeader: "({{ft}} Fast-Trans pakketten{{othersText}})",
      retourOthersText: " · {{n}} andere subco's",
      retourCols: { packageNo: "Pakketnr.", firm: "Firma", line: "Lijn", recipient: "Ontvanger & Adres", postcode: "Postcode", weight: "Kg", reason: "Oorzaak", time: "Tijd" },
      insightsTitle: "Automatische Managementinzichten & Acties",
      shownRange: "Getoond: {{from}} - {{to}} / {{total}}",
      noTourData: "Geen ritdata voor deze datum."
    },
    monthlyInvoice: {
      title: "DPD Maandelijkse Facturenoverzicht",
      subtitle: "Maandelijkse pakketten, productcodes en premie per rit uit Fast-Trans Subco Details-bestanden.",
      month: "Maand",
      kpi: { totalParcels: "Totaal Pakketten", reliability: "Gem. Betrouwbaarheid", basePay: "Basisvergoeding", netPay: "Netto Uitbetaling",
             daysAndTours: "{{days}} dagen / {{tours}} ritten", bonusMalus: "Bonus {{bonus}} / Malus {{malus}}", netSubtitle: "Basis + Bonus − Malus" },
      breakdownTitle: "Maandelijkse Verdeling per Rit", productTitle: "Productcode Verdeling (Maand Totaal)",
      productHint: "Codes: 03D=Standaard, 03XD=Extra, 03SD=Zaterdag, 04DAD/04DAV=Weekend, 05MAST=Master, etc.",
      cols: { tour: "Rit", activeDays: "Actieve Dagen", delivered: "Bezorgd", stops: "Stops", pickup: "Pickup", km: "Km", reliabilityPct: "Betr. %", basePay: "Basis (€)", bonus: "Bonus", malus: "Malus", netPay: "Netto (€)", totalRow: "Totaal" },
      empty: "Geen factuurgegevens voor deze maand. Subco Details Excels komen via e-mail.",
      sourceFiles: "Bron: {{files}}"
    },
    heatmap: {
      title: "DPD Retour Heatmap",
      subtitle: "Postcode (eerste 2 cijfers) × redencode matrix. Toont probleemgebieden en oorzaken.",
      subcoFilter: "Subco (optioneel bv: fast)", ftOnly: "Alleen Fast-Trans", clearFilter: "Filter Wissen",
      stats: { totalRetour: "Totaal Retour", pcRegion: "PC Regio's", reasonCodes: "Unieke Redencodes" },
      cols: { pcRegion: "PC / Regio", total: "Totaal" },
      legendLow: "Laag → Hoog", legendMax: "Max: {{n}} pakketten / cel", legendDensity: "Dichtheid:",
      reasonLegendTitle: "Redencode Beschrijvingen",
      empty: "Geen retour data voor gekozen filters."
    },
    subcoComparison: {
      title: "DPD Subco Vergelijking",
      subtitle: "Vergelijk Fast-Trans met andere subco's op retourvolume en oorzaken. Retour data omvat alle subco's; bezorg- & km-data alleen Fast-Trans.",
      ftBlockTitle: "Fast-Trans (Uw Bedrijf) — {{days}} dagen",
      metrics: { delivered: "Bezorgd", retour: "Retour", success: "Slaagpercentage", totalKm: "Totaal Km" },
      stats: { totalRetour: "Totaal Retour", activeSubco: "Actieve Subco's", activeDays: "Actieve Dagen" },
      trendTitle: "Wekelijkse Retour Trend — Top 6 Subco's",
      cols: { subco: "Subco", retour: "Retour", share: "Aandeel %", chart: "Grafiek", tours: "Ritten", activeDays: "Actieve Dagen", avgDay: "Gem/Dag", weight: "Gewicht (kg)" },
      rootCauses: "Top Retour Oorzaken:",
      empty: "Geen retour data voor gekozen periode.",
      hint: "Klik een rij om de meest voorkomende retour-redencodes van deze subco te zien."
    },
    retourReport: {
      title: "DPD Retour Rapport",
      subtitle: "Niet-bezorgde pakketten — server-side paginering + geavanceerde filters",
      filters: { tour: "Rit (Q10)", subco: "Subco", reason: "Redencode (25)", pc: "Postcode (35)", q: "Zoek pakket/ontvanger..." },
      totalPackages: "{{count}} pakketten", filtered: "(gefilterd)", clearAll: "Filters Wissen",
      aggTitle: "Per {{title}} ({{count}})",
      cols: { packageNo: "Pakketnr.", tour: "Rit", time: "Tijd", reason: "Reden", weight: "Kg", pc: "PC", recipient: "Ontvanger", subco: "Subco" },
      shownRange: "Getoond: {{from}} - {{to}} / {{total}}",
      empty: "Geen retour records match de filters."
    },
    courierMapping: {
      title: "DPD Chauffeur Koppeling",
      subtitle: "Koppel chauffeurnamen in DPD RouteDataLog aan echte HR-medewerkers. Accepteer fuzzy-suggesties of kies handmatig.",
      autoMinLabel: "Auto-match score ≥", autoApply: "Automatisch Toepassen",
      stats: { total: "Totaal Chauffeurs", mapped: "Gekoppeld", unmapped: "Niet Gekoppeld" },
      cols: { courier: "DPD Chauffeur", status: "Status", match: "Gematchte Medewerker / Fuzzy Suggesties", manual: "Handmatige Keuze", action: "Actie" },
      statusMapped: "Gekoppeld", statusUnmapped: "Geen",
      noSuggestion: "Geen suggestie — handmatig kiezen",
      pickEmployee: "Medewerker kiezen...", searchPlaceholder: "Zoek op naam of e-mail...",
      noEmployee: "Geen medewerker gevonden.",
      remove: "Verwijderen", empty: "Geen chauffeurs gevonden in DPD RouteDataLog.",
      hint: "💡 Fuzzy score: 100 = volledige naammatch, 50 = één deel matcht. Auto-toepassen slaat {{score}}+ matches op."
    },
    fileCategories: {
      title: "DPD Bestandscategorieën",
      subtitle: "Blader DPD-bijlagen per type & importeer per bestand of per categorie. Duplicaten worden overgeslagen; junk-bestanden (image, signature) worden gefilterd.",
      ingestAll: "Alles Importeren", ingestCat: "Deze Categorie Importeren", deleteAll: "Alles Verwijderen",
      resetAll: "Alle Rapporten & Analyses Resetten", resetCat: "Deze Categorie Resetten",
      resetAllTitle: "Alle DPD-gegevens resetten?",
      resetAllBody: "Alle geparste rapporten en analyses worden verwijderd (mailarchief blijft behouden). Daarna kunt u met 'Alles Importeren' de Excels opnieuw laten verwerken.",
      resetCatTitle: "Categorie {{cat}} resetten?",
      resetCatBody: "Alle geparste rijen en ingest-logs voor deze categorie worden verwijderd. Mailarchief blijft; u kunt opnieuw importeren.",
      resetDone: "Reset klaar: {{n}} records verwijderd",
      resetFailed: "Reset mislukt",
      mailDate: "Maildatum",
      totalSummary: "Totaal {{files}} bestanden, {{cats}} categorieën",
      countFiles: "{{n}} bestanden", countIngested: "({{n}} geïmporteerd)",
      cols: { file: "Bestand", date: "Datum", mailDate: "Maildatum", archived: "Gearchiveerd", from: "Afzender", status: "Status", action: "Actie" },
      excludePlaceholder: "Uitsluiten op bestandsnaam (bv. HYK, test)",
      filteredHint: "{{n}} bestanden uitgefilterd",
      sort: {
        mailDesc: "Maildatum (Nieuw → Oud)",
        mailAsc: "Maildatum (Oud → Nieuw)",
        arcDesc: "Gearchiveerd (Nieuw → Oud)",
        arcAsc: "Gearchiveerd (Oud → Nieuw)",
      },
      status: { rows: "{{n}} rijen", waiting: "Wachten", junk: "Junk" },
      toast: {
        alreadyIngested: "Al geïmporteerd",
        importedRows: "{{n}} rijen geïmporteerd",
        importFailed: "Import mislukt",
        bulkResult: "{{ingested}} bestanden verwerkt",
        bulkAlready: "{{n}} al geïmporteerd", bulkJunk: "{{n}} junk overgeslagen", bulkUnknown: "{{n}} onbekend overgeslagen", bulkErrors: "{{n}} fouten",
        bulkFailed: "Bulk import mislukt",
        previewFailed: "Voorbeeld mislukt",
        deleted: "Bestand verwijderd", deleteFailed: "Verwijderen mislukt",
        junkDeleted: "{{done}} junk-bestanden verwijderd"
      },
      dialog: {
        deleteFileTitle: "Bestand verwijderen?",
        deleteFileBody: "{{filename}} wordt permanent verwijderd. Dit kan niet ongedaan worden gemaakt.",
        deleteJunkTitle: "{{n}} junk-bestanden verwijderen?",
        deleteJunkBody: "Dit kan niet ongedaan worden gemaakt. Bestanden worden verwijderd uit mailarchief en S3."
      },
      emptyState: "Nog geen DPD-bestanden in mailarchief.",
      emptyHint: "Definieer een regel voor dpd.be onder Instellingen → Mailarchiefregels."
    },
    alerts: {
      widgetTitle: "DPD Waarschuwingen",
      severityHigh: "hoog", severityMedium: "gemiddeld", severityLow: "laag",
      badges: { high: "Hoog", medium: "Gemiddeld", low: "Laag" },
      types: { lowDelivery: "Lage Bezorging", highRetour: "Hoge Retour" },
      detailLink: "Details →",
      moreAlerts: "+{{n}} meer waarschuwingen — "
    },
    analytics: {
      title: "DPD Analytics & Inzichten",
      subtitle: "Fast-Trans exclusief — jaarlijkse trends, vergelijkingen, voorspellingen en AI-samenvatting",
      year: "Jaar", refresh: "Vernieuwen", loading: "Analytics berekenen…",
      empty: "Geen Fast-Trans gegevens voor dit jaar. Importeer eerst de Excels.",
      kpi: {
        packages: "Totaal Pakketten", retour: "Totaal Retour", deliveryRate: "Bezorgpercentage",
        activeDays: "Actieve Dagen", activeCouriers: "Actieve Chauffeurs", activeTours: "Actieve Ritten", avgDaily: "Dagelijks Gem.",
      },
      yoy: {
        title: "Jaarvergelijking ({{prev}} vs {{cur}})",
        packages: "Pakketvolume", retour: "Retour Aantal", deliveryRate: "Bezorgpercentage", couriers: "Actieve Chauffeurs",
      },
      monthly: { title: "Maandelijkse Trend", subtitle: "Laatste 24 maanden bezorg-/retourvolume", packages: "Pakketten", retour: "Retour", deliveryPct: "Bezorg %" },
      dow: { title: "Dag-van-de-Week Patroon", subtitle: "Welke dagen zijn kritiek — volume & succespercentage" },
      reasons: { title: "Retour Reden Trend", topTitle: "Meest Voorkomende Retour Redenen", share: "Aandeel" },
      drivers: {
        title: "Chauffeur Ranking & Aanbevelingen",
        subtitle: "Score = 60% bezorging + 30% volume + 10% consistentie",
        rank: "Rang", courier: "Chauffeur", score: "Score", packages: "Pakketten", retour: "Retour", deliveryPct: "Bezorg %", days: "Dagen", recommendation: "Aanbeveling",
      },
      forecast: {
        title: "Voorspelling", nextMonthRetour: "Volgende Maand Retour Schatting", nextMonthPackages: "Verwacht Pakketvolume",
        based: "Gebaseerd op laatste {{n}} maanden", trend: { up: "Stijgend", down: "Dalend", flat: "Vlak" },
      },
      insights: { title: "Automatische Inzichten", subtitle: "Patronen uit de cijfers" },
      ai: { title: "Analyse (Claude Sonnet)", subtitle: "Managementrapportage — natuurlijke taal beoordeling", loading: "Analyse genereren…", error: "Analyse niet beschikbaar" },
      pdf: { export: "PDF Downloaden", generating: "PDF genereren…", done: "PDF klaar", failed: "PDF genereren mislukt", fileName: "DPD-Analytics-{{year}}.pdf" },
      driver: { modalTitle: "Chauffeur Detail — {{name}}", coaching: "Persoonlijke Coaching Notitie", vsAvg: "vs Bedrijfsgemiddelde", rank: "Rang", personalTrend: "Persoonlijke Maandelijkse Trend", yourReasons: "Jouw Retour Redenen", close: "Sluiten", clickHint: "Klik op rij voor details" },
    }
  }
};

export default nl;
